import React from 'react'

const LogInIllustration = props => (
  <svg
    {...props}
    width="490"
    height="516"
    viewBox="0 0 490 516"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_118_403)">
      <path
        d="M466 267.5H24C11.021 267.5 0.5 278.021 0.5 291V492C0.5 504.979 11.021 515.5 24 515.5H466C478.979 515.5 489.5 504.979 489.5 492V291C489.5 278.021 478.979 267.5 466 267.5Z"
        fill="white"
        stroke="#E2E2FC"
      />
      <g opacity="0.4" filter="url(#filter0_f_118_403)">
        <path
          d="M248.663 471.64C326.332 471.64 389.294 435.607 389.294 391.157C389.294 346.707 326.332 310.674 248.663 310.674C170.995 310.674 108.032 346.707 108.032 391.157C108.032 435.607 170.995 471.64 248.663 471.64Z"
          fill="#E2E2FC"
        />
      </g>
      <path
        d="M418.285 363.232C418.129 365.554 419.911 367.594 422.232 367.75C424.553 367.907 426.594 366.124 426.75 363.803C426.906 361.482 425.124 359.442 422.803 359.285C420.482 359.129 418.446 360.843 418.285 363.232Z"
        stroke="#1D2943"
        strokeMiterlimit="10"
      />
      <path
        d="M353.935 474.388H335.723V463.346H317.116V450.295L303.26 432.727H282.277V382.031H254.96V319.288L213.124 365.401V446.28H202.306V483.188H194.784L191.1 469.702H138.525L132 485.933V495H363.04V485.933L353.935 474.388Z"
        fill="#E2E2FC"
      />
      <path
        d="M224.409 376.874H221.879V379.442H224.409V376.874Z"
        fill="white"
      />
      <path
        d="M230.565 376.874H228.035V379.442H230.565V376.874Z"
        fill="white"
      />
      <path
        d="M236.724 376.874H234.193V379.442H236.724V376.874Z"
        fill="white"
      />
      <path d="M224.409 383.8H221.879V386.368H224.409V383.8Z" fill="white" />
      <path d="M230.565 383.8H228.035V386.368H230.565V383.8Z" fill="white" />
      <path d="M236.724 383.8H234.193V386.368H236.724V383.8Z" fill="white" />
      <path
        d="M224.409 390.724H221.879V393.292H224.409V390.724Z"
        fill="white"
      />
      <path
        d="M230.565 390.724H228.035V393.292H230.565V390.724Z"
        fill="white"
      />
      <path
        d="M236.724 390.724H234.193V393.292H236.724V390.724Z"
        fill="white"
      />
      <path
        d="M224.409 397.648H221.879V400.216H224.409V397.648Z"
        fill="white"
      />
      <path
        d="M230.565 397.648H228.035V400.216H230.565V397.648Z"
        fill="white"
      />
      <path
        d="M236.724 397.648H234.193V400.216H236.724V397.648Z"
        fill="white"
      />
      <path
        d="M224.409 404.573H221.879V407.141H224.409V404.573Z"
        fill="white"
      />
      <path
        d="M230.565 404.573H228.035V407.141H230.565V404.573Z"
        fill="white"
      />
      <path
        d="M236.724 404.573H234.193V407.141H236.724V404.573Z"
        fill="white"
      />
      <path
        d="M224.409 411.497H221.879V414.065H224.409V411.497Z"
        fill="white"
      />
      <path
        d="M230.565 411.497H228.035V414.065H230.565V411.497Z"
        fill="white"
      />
      <path
        d="M236.724 411.497H234.193V414.065H236.724V411.497Z"
        fill="white"
      />
      <path
        d="M224.409 418.421H221.879V420.989H224.409V418.421Z"
        fill="white"
      />
      <path
        d="M230.565 418.421H228.035V420.989H230.565V418.421Z"
        fill="white"
      />
      <path
        d="M236.724 418.421H234.193V420.989H236.724V418.421Z"
        fill="white"
      />
      <path
        d="M224.409 425.347H221.879V427.915H224.409V425.347Z"
        fill="white"
      />
      <path
        d="M230.565 425.347H228.035V427.915H230.565V425.347Z"
        fill="white"
      />
      <path
        d="M236.724 425.347H234.193V427.915H236.724V425.347Z"
        fill="white"
      />
      <path
        d="M224.409 432.269H221.879V434.837H224.409V432.269Z"
        fill="white"
      />
      <path
        d="M230.565 432.269H228.035V434.837H230.565V432.269Z"
        fill="white"
      />
      <path
        d="M236.724 432.269H234.193V434.837H236.724V432.269Z"
        fill="white"
      />
      <path
        d="M259.696 393.117H257.166V395.685H259.696V393.117Z"
        fill="white"
      />
      <path d="M265.851 393.117H263.32V395.685H265.851V393.117Z" fill="white" />
      <path d="M272.011 393.117H269.48V395.685H272.011V393.117Z" fill="white" />
      <path d="M259.696 400.042H257.166V402.61H259.696V400.042Z" fill="white" />
      <path d="M265.851 400.042H263.32V402.61H265.851V400.042Z" fill="white" />
      <path d="M272.011 400.042H269.48V402.61H272.011V400.042Z" fill="white" />
      <path
        d="M259.696 406.967H257.166V409.535H259.696V406.967Z"
        fill="white"
      />
      <path d="M265.851 406.967H263.32V409.535H265.851V406.967Z" fill="white" />
      <path d="M272.011 406.967H269.48V409.535H272.011V406.967Z" fill="white" />
      <path d="M259.696 413.89H257.166V416.458H259.696V413.89Z" fill="white" />
      <path d="M265.851 413.89H263.32V416.458H265.851V413.89Z" fill="white" />
      <path d="M272.011 413.89H269.48V416.458H272.011V413.89Z" fill="white" />
      <path
        d="M259.696 420.815H257.166V423.383H259.696V420.815Z"
        fill="white"
      />
      <path d="M265.851 420.815H263.32V423.383H265.851V420.815Z" fill="white" />
      <path d="M272.011 420.815H269.48V423.383H272.011V420.815Z" fill="white" />
      <path
        d="M259.696 427.739H257.166V430.307H259.696V427.739Z"
        fill="white"
      />
      <path d="M265.851 427.739H263.32V430.307H265.851V427.739Z" fill="white" />
      <path d="M272.011 427.739H269.48V430.307H272.011V427.739Z" fill="white" />
      <path
        d="M259.696 434.664H257.166V437.232H259.696V434.664Z"
        fill="white"
      />
      <path d="M265.851 434.664H263.32V437.232H265.851V434.664Z" fill="white" />
      <path d="M272.011 434.664H269.48V437.232H272.011V434.664Z" fill="white" />
      <path
        d="M259.696 441.589H257.166V444.157H259.696V441.589Z"
        fill="white"
      />
      <path d="M265.851 441.589H263.32V444.157H265.851V441.589Z" fill="white" />
      <path d="M272.011 441.589H269.48V444.157H272.011V441.589Z" fill="white" />
      <path
        d="M259.696 448.511H257.166V451.079H259.696V448.511Z"
        fill="white"
      />
      <path d="M265.851 448.511H263.32V451.079H265.851V448.511Z" fill="white" />
      <path d="M272.011 448.511H269.48V451.079H272.011V448.511Z" fill="white" />
      <path
        d="M385.88 304.324L385.678 304.522L385.404 304.451C380.71 303.235 375.441 304.59 372.042 308.5H456.026C455.89 308.422 455.758 308.343 455.629 308.264C455.547 308.215 455.468 308.166 455.39 308.118C455.135 307.961 454.89 307.81 454.625 307.665C453.309 306.943 451.488 306.342 446.806 307.097C446.362 307.17 445.834 307.272 445.249 307.386C443.799 307.668 442.002 308.017 440.293 308.15C439.085 308.245 437.877 308.237 436.816 308.016C435.756 307.795 434.795 307.35 434.149 306.529L434.148 306.527C433.348 305.501 433.004 304.166 432.692 302.959L432.687 302.941C432.362 301.682 432.069 300.555 431.433 299.716C430.244 298.16 428.919 297.381 427.585 297.09C426.24 296.796 424.839 296.988 423.495 297.453C420.794 298.388 418.443 300.39 417.511 301.425L416.707 300.84C417.74 299.06 417.906 296.789 417.401 294.632C416.896 292.473 415.733 290.497 414.202 289.311C411.12 286.922 406.924 287.07 403.348 288.745C399.757 290.427 396.741 293.381 393.694 296.411C392.589 297.516 391.466 298.666 390.34 299.819C388.85 301.346 387.353 302.879 385.88 304.324Z"
        stroke="#C2D9F0"
      />
      <path
        d="M126.03 317.649L126.227 317.829L126.486 317.766C132.277 316.361 138.775 317.953 142.92 322.5H40.5264C40.7734 322.374 41.0084 322.243 41.2374 322.113C41.3344 322.057 41.4304 322.002 41.5254 321.948C41.8344 321.769 42.1354 321.596 42.4604 321.429C44.0884 320.593 46.3304 319.909 52.0344 320.771C52.5784 320.855 53.2244 320.972 53.9364 321.102C55.6944 321.421 57.8594 321.815 59.9254 321.967C61.3854 322.074 62.8364 322.064 64.1054 321.817C65.3714 321.569 66.5104 321.074 67.2754 320.162L67.2774 320.161C68.2394 319.004 68.6554 317.496 69.0354 316.118L69.0384 316.106C69.4324 314.678 69.7904 313.387 70.5714 312.421C72.0244 310.641 73.6534 309.739 75.3064 309.401C76.9704 309.06 78.6974 309.283 80.3424 309.817C83.6464 310.888 86.5134 313.176 87.6514 314.359L88.4364 313.749C87.1734 311.712 86.9734 309.121 87.5874 306.664C88.2024 304.206 89.6174 301.945 91.4974 300.581C95.2844 297.833 100.435 298.01 104.803 299.926C109.182 301.848 112.855 305.217 116.549 308.659C117.892 309.916 119.254 311.222 120.62 312.533C122.428 314.267 124.243 316.007 126.03 317.649Z"
        fill="#C2D9F0"
        stroke="#C2D9F0"
      />
      <path
        d="M433.693 380.624C433.585 382.24 434.825 383.66 436.441 383.769C438.056 383.878 439.476 382.637 439.585 381.021C439.694 379.406 438.453 377.986 436.838 377.877C435.222 377.768 433.805 378.961 433.693 380.624Z"
        fill="#004360"
      />
      <path
        d="M289.091 367.818C292.744 369.766 300.758 370.624 301.981 367.222C302.712 365.321 302.958 363.299 302.699 361.303C302.699 361.303 296.212 353.392 293.274 355.584C288.674 359.111 285.3 364.133 289.091 367.818Z"
        fill="#F7C689"
      />
      <path
        d="M294.592 359.263C294.592 359.263 294.238 365.039 299.074 366.002C303.909 366.964 301.861 360.34 301.861 360.34L299.62 357.853H295.246L294.592 359.263Z"
        fill="#F7C689"
      />
      <path
        d="M352.119 332.227C352.119 332.227 357.263 328.233 363.561 333.782C369.86 339.332 367.347 365.7 367.347 365.7L353.191 362.827V344.55L352.119 332.227Z"
        fill="#273754"
      />
      <path
        d="M297.519 365.439C297.473 365.449 297.425 365.449 297.379 365.439C294.849 364.086 294.356 361.131 294.334 361.008C294.325 360.946 294.344 360.883 294.386 360.833C294.428 360.783 294.49 360.75 294.559 360.741C294.627 360.737 294.693 360.756 294.747 360.792C294.8 360.829 294.836 360.882 294.849 360.941C294.849 360.941 295.331 363.8 297.647 365.039C297.678 365.055 297.704 365.076 297.725 365.101C297.746 365.126 297.761 365.154 297.769 365.185C297.777 365.215 297.778 365.247 297.772 365.277C297.766 365.308 297.753 365.337 297.733 365.363C297.707 365.39 297.674 365.412 297.637 365.425C297.599 365.438 297.559 365.443 297.519 365.439Z"
        fill="#00112B"
      />
      <path
        d="M375.983 438.752L390.114 439.438L386.447 451.448L375.039 453.335L375.983 438.752Z"
        fill="#F7C689"
      />
      <path
        d="M335.387 385.493C335.387 385.493 316.313 440.287 330.948 450.666C345.584 461.045 377.375 456.127 377.375 456.127L378.909 434.149L361.453 432.738L342.539 387.628L335.387 385.493Z"
        fill="#526181"
      />
      <path
        d="M365.081 470.843V484.511L350.864 480.098L349.545 469.843L365.081 470.843Z"
        fill="#F7C689"
      />
      <path
        d="M364.986 387.228C364.986 387.228 368.717 399.122 368.278 406.938C367.838 414.753 367.206 432.481 367.506 435.607C367.806 438.733 369.747 473.245 369.747 473.245C365.211 474.414 360.528 475.074 355.808 475.209C352.028 475.33 348.243 475.161 344.496 474.703C344.496 474.703 336.615 436.293 337.055 424.828C337.494 413.362 337.998 387.656 337.998 387.656L364.986 387.228Z"
        fill="#526181"
      />
      <path
        d="M327.246 493.975C327.16 493.964 327.077 493.937 327.002 493.896C326.928 493.856 326.863 493.803 326.812 493.739C326.761 493.676 326.725 493.605 326.706 493.529C326.686 493.453 326.684 493.375 326.7 493.299C326.957 491.735 327.922 487.361 330.656 485.464C334.012 483.138 341.142 482.109 343.705 480.556C346.267 479.002 349.066 475.294 350.664 475.962C352.261 476.629 355.21 479.774 359.424 479.231C363.637 478.687 365.557 477.763 366.715 478.659C367.873 479.555 368.784 492.26 368.312 493.022C367.84 493.785 361.879 493.184 361.375 493.318C360.871 493.451 359.338 490.458 358.373 490.916C357.408 491.373 356.228 492.822 354.824 493.499C353.419 494.175 331.503 494.395 327.246 493.975Z"
        fill="white"
      />
      <g filter="url(#filter1_d_118_403)">
        <path
          d="M400.635 473.302C400.622 473.379 400.592 473.453 400.547 473.519C400.501 473.585 400.441 473.643 400.37 473.688C400.299 473.733 400.219 473.765 400.134 473.783C400.048 473.8 399.96 473.802 399.874 473.788C398.116 473.559 393.194 472.721 391.05 470.29C388.423 467.317 387.243 460.988 385.474 458.72C383.705 456.451 379.534 453.954 380.285 452.553C381.035 451.152 384.574 448.493 383.93 444.747C383.287 441.001 382.258 439.295 383.255 438.266C384.252 437.237 398.545 436.36 399.413 436.789C400.282 437.218 399.617 442.507 399.767 442.965C399.917 443.422 396.55 444.785 397.076 445.643C397.601 446.501 399.22 447.549 400.003 448.779C400.786 450.008 401.129 469.509 400.635 473.302Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter2_d_118_403)">
        <path
          d="M399.761 436.411C400.559 436.883 400.155 442.292 400.291 442.77C400.427 443.248 397.435 444.47 397.941 445.376C398.447 446.283 399.955 447.426 400.698 448.76C401.441 450.094 402.386 470.109 402.079 473.98C402.071 474.059 402.047 474.133 402.009 474.199C401.971 474.266 401.919 474.322 401.856 474.365C401.794 474.409 401.722 474.438 401.646 474.451C401.569 474.465 401.49 474.462 401.411 474.443C400.161 474.185 398.926 473.818 397.721 473.346L396.001 436.148C397.247 436.087 398.508 436.175 399.761 436.411Z"
          fill="#4F5B94"
        />
      </g>
      <path
        d="M340.627 454.145C340.565 454.143 340.505 454.122 340.458 454.086C340.411 454.049 340.38 453.999 340.37 453.945C336.639 434.13 340.295 402.163 340.627 399.418L334.837 397.731C334.771 397.711 334.716 397.669 334.684 397.614C334.652 397.559 334.646 397.495 334.666 397.435C334.692 397.379 334.74 397.334 334.802 397.308C334.863 397.281 334.933 397.276 334.998 397.292L340.992 399.036C341.046 399.053 341.093 399.086 341.124 399.129C341.155 399.172 341.169 399.224 341.164 399.275C341.164 399.618 337.014 433.319 340.885 453.868C340.891 453.899 340.89 453.929 340.883 453.959C340.875 453.989 340.861 454.017 340.841 454.042C340.821 454.067 340.796 454.088 340.766 454.104C340.737 454.12 340.704 454.131 340.67 454.135L340.627 454.145Z"
        fill="#273754"
      />
      <path
        d="M363.069 400.294C357.869 400.294 355.896 395.529 355.874 395.452C355.862 395.424 355.857 395.394 355.858 395.364C355.859 395.334 355.866 395.304 355.88 395.277C355.894 395.25 355.914 395.225 355.939 395.204C355.964 395.184 355.993 395.168 356.024 395.157C356.056 395.146 356.09 395.141 356.124 395.142C356.158 395.143 356.191 395.15 356.222 395.162C356.253 395.175 356.28 395.192 356.304 395.214C356.327 395.236 356.345 395.262 356.357 395.29C356.443 395.51 358.501 400.571 364.302 399.741C364.337 399.732 364.373 399.73 364.409 399.734C364.445 399.739 364.48 399.75 364.511 399.767C364.541 399.784 364.568 399.807 364.588 399.834C364.608 399.86 364.622 399.891 364.628 399.923C364.634 399.954 364.632 399.987 364.623 400.018C364.614 400.05 364.598 400.079 364.575 400.104C364.552 400.129 364.524 400.15 364.492 400.164C364.459 400.179 364.424 400.188 364.388 400.189C363.952 400.256 363.511 400.291 363.069 400.294Z"
        fill="#273754"
      />
      <path
        d="M367.78 449.379C367.711 449.379 367.644 449.355 367.594 449.313C367.545 449.27 367.515 449.212 367.512 449.15L367.18 433.234C367.178 433.203 367.184 433.172 367.196 433.143C367.209 433.114 367.227 433.088 367.251 433.066C367.275 433.043 367.304 433.026 367.336 433.014C367.368 433.002 367.403 432.995 367.437 432.995C367.505 432.995 367.571 433.019 367.619 433.062C367.667 433.105 367.695 433.163 367.695 433.224L368.038 449.141C368.035 449.202 368.008 449.26 367.96 449.304C367.913 449.348 367.849 449.375 367.78 449.379Z"
        fill="#273754"
      />
      <path
        d="M347.569 481.738H347.515L343.655 480.785C343.62 480.779 343.587 480.767 343.557 480.749C343.528 480.731 343.503 480.707 343.484 480.68C343.465 480.653 343.453 480.623 343.448 480.592C343.443 480.56 343.445 480.528 343.455 480.498C343.465 480.467 343.482 480.439 343.504 480.414C343.527 480.39 343.555 480.37 343.587 480.355C343.619 480.341 343.654 480.333 343.69 480.331C343.726 480.33 343.761 480.335 343.795 480.346L347.666 481.299C347.698 481.308 347.728 481.322 347.754 481.341C347.78 481.361 347.802 481.384 347.818 481.411C347.834 481.437 347.844 481.466 347.847 481.496C347.85 481.526 347.847 481.556 347.837 481.585C347.82 481.635 347.784 481.677 347.734 481.705C347.685 481.733 347.627 481.745 347.569 481.738Z"
        fill="#5C69A5"
      />
      <path
        d="M345.643 483.425H345.568L340.593 481.995C340.561 481.986 340.53 481.972 340.504 481.953C340.478 481.934 340.456 481.91 340.44 481.884C340.424 481.857 340.415 481.828 340.411 481.798C340.408 481.768 340.412 481.738 340.421 481.709C340.444 481.65 340.491 481.601 340.553 481.573C340.615 481.544 340.687 481.538 340.754 481.556L345.718 482.986C345.784 483.006 345.839 483.048 345.872 483.103C345.904 483.158 345.91 483.222 345.89 483.282C345.87 483.325 345.836 483.362 345.792 483.388C345.748 483.413 345.696 483.426 345.643 483.425Z"
        fill="#5C69A5"
      />
      <path
        d="M386.112 459.664H386.016C385.953 459.638 385.903 459.593 385.877 459.536C385.851 459.479 385.851 459.416 385.876 459.359L387.399 456.061C387.425 456.006 387.474 455.962 387.536 455.938C387.599 455.915 387.669 455.915 387.731 455.937C387.763 455.947 387.792 455.964 387.817 455.984C387.841 456.005 387.861 456.029 387.875 456.057C387.889 456.084 387.897 456.114 387.898 456.144C387.899 456.174 387.893 456.204 387.881 456.232L386.359 459.53C386.337 459.572 386.302 459.607 386.258 459.63C386.214 459.654 386.163 459.666 386.112 459.664Z"
        fill="#5C69A5"
      />
      <path
        d="M387.081 462.466H386.974C386.912 462.437 386.865 462.389 386.841 462.331C386.817 462.272 386.819 462.208 386.845 462.151L388.99 457.939C389.004 457.911 389.024 457.886 389.049 457.865C389.073 457.844 389.103 457.828 389.134 457.818C389.166 457.807 389.2 457.802 389.234 457.803C389.269 457.804 389.302 457.811 389.333 457.824C389.394 457.851 389.441 457.897 389.465 457.954C389.489 458.011 389.488 458.073 389.462 458.129L387.317 462.351C387.294 462.388 387.259 462.418 387.217 462.438C387.176 462.458 387.129 462.468 387.081 462.466Z"
        fill="#5C69A5"
      />
      <path
        d="M353.788 391.04C353.788 391.04 338.777 391.86 332.719 389.248L333.073 373.188C333.073 373.188 334.541 353.611 339.173 352.792C343.219 352.245 347.325 352.152 351.397 352.515L366.483 371.501L353.788 391.04Z"
        fill="#004360"
      />
      <path
        d="M338.98 342.458C338.211 341.589 337.655 340.583 337.349 339.505C337.044 338.428 336.996 337.303 337.208 336.207C337.312 334.919 337.929 333.708 338.945 332.799C338.945 332.799 336.996 329.284 342.748 329.477C346.033 329.531 349.222 330.489 351.891 332.222C352.251 332.062 352.647 331.976 353.049 331.971C353.45 331.967 353.848 332.044 354.213 332.196C354.578 332.349 354.9 332.573 355.156 332.853C355.413 333.133 355.596 333.462 355.694 333.814C356.875 336.581 355.694 340.673 355.694 340.673L338.98 342.458Z"
        fill="#273754"
      />
      <path
        d="M351.434 345.875L351.278 352.085C351.278 352.085 349.972 353.844 345.852 354.066C342.798 354.225 341.863 352.816 341.863 352.816L342.738 347.401L350.188 346.098L351.434 345.875Z"
        fill="#F7C689"
      />
      <path
        d="M352 345.875C351.962 346.104 351.887 346.326 351.779 346.533C350.057 349.925 344.275 351.229 342.43 351.344L342.946 347.975L352 345.875Z"
        fill="#C6714D"
      />
      <path
        d="M341.934 333.748C341.934 333.748 338.067 341.466 339.411 345.817C340.755 350.168 345.223 349.519 347.899 348.693C349.422 348.267 350.787 347.482 351.848 346.424C352.608 346.626 353.42 346.61 354.17 346.379C354.919 346.148 355.567 345.714 356.022 345.137C357.708 343.046 356.694 340.713 355.279 340.17C354.76 340.032 354.214 339.992 353.676 340.051C353.138 340.111 352.62 340.269 352.155 340.515L353.499 338.277C353.499 338.277 347.97 326.814 341.934 333.748Z"
        fill="#F7C689"
      />
      <path
        d="M343.82 340.104L342.529 342.757L343.279 343.218"
        stroke="#273754"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M333.297 357.883C334.108 357.433 335.053 357.253 335.954 357.388C336.945 357.478 337.575 357.703 338.296 358.288C337.935 359.098 337.215 359.593 335.954 359.323C334.963 359.143 334.017 358.648 333.297 357.883Z"
        fill="white"
      />
      <path
        d="M338.299 358.244C336.903 357.163 334.967 357.028 333.391 357.883"
        stroke="#273754"
        strokeWidth="0.7978"
        strokeMiterlimit="10"
      />
      <path
        d="M333.297 357.883C333.837 358.468 334.558 358.918 335.323 359.143C335.414 359.008 335.459 358.873 335.504 358.738C335.639 358.243 335.594 357.748 335.414 357.343C334.693 357.343 333.927 357.523 333.297 357.883Z"
        fill="#273754"
      />
      <path
        d="M351.988 340.355C351.988 340.355 348.227 341.051 345.602 337.319C342.976 333.587 343.237 332.048 343.237 332.048L340.647 335.917C340.314 334.436 340.521 332.9 341.238 331.531C342.421 329.834 343.686 330.182 343.686 330.182L351.965 332.006L354.164 337.931L351.988 340.355Z"
        fill="#273754"
      />
      <path
        d="M346.943 332.031C343.827 330.414 338.445 332.692 338.445 332.692C338.445 332.692 343.544 326.953 349.068 329.387C350.169 329.872 351.224 330.685 352.042 331.591C353.377 333.069 353.741 336.88 353.317 339.966L352.467 340.406C352.467 340.406 351.617 334.457 346.943 332.031Z"
        fill="#004360"
      />
      <path
        d="M330.242 331.427L337.473 334.938C340.025 330.988 344.704 330.549 349.383 334.06C349.383 334.06 345.98 327.915 344.704 326.599C343.428 325.282 340.876 322.648 336.197 324.843C331.518 327.037 330.526 329.817 330.242 331.427Z"
        fill="#D72B4F"
      />
      <path
        d="M352.384 343.824C352.349 343.825 352.315 343.819 352.283 343.806C352.25 343.793 352.221 343.775 352.197 343.751C352.172 343.727 352.153 343.699 352.139 343.669C352.126 343.638 352.119 343.605 352.119 343.572C352.119 343.539 352.126 343.506 352.139 343.476C352.153 343.445 352.172 343.417 352.197 343.394L354.401 341.16C354.452 341.115 354.519 341.09 354.588 341.09C354.658 341.09 354.725 341.115 354.776 341.16C354.8 341.183 354.82 341.211 354.833 341.242C354.847 341.272 354.854 341.305 354.854 341.338C354.854 341.371 354.847 341.404 354.833 341.435C354.82 341.465 354.8 341.493 354.776 341.517L352.572 343.751C352.548 343.776 352.519 343.795 352.487 343.808C352.454 343.821 352.419 343.826 352.384 343.824Z"
        fill="#00112B"
      />
      <path
        d="M354.893 343.421L353.37 343.215C353.301 343.205 353.238 343.17 353.196 343.119C353.154 343.067 353.136 343.003 353.145 342.939C353.15 342.907 353.162 342.877 353.18 342.85C353.198 342.824 353.222 342.8 353.25 342.782C353.278 342.763 353.309 342.75 353.343 342.744C353.377 342.737 353.411 342.736 353.445 342.742L354.936 342.948C355.004 342.948 355.07 342.973 355.118 343.018C355.166 343.062 355.193 343.122 355.193 343.185C355.193 343.248 355.166 343.308 355.118 343.352C355.07 343.396 355.004 343.421 354.936 343.421H354.893Z"
        fill="#00112B"
      />
      <path
        d="M339.496 336.988C339.409 336.99 339.324 336.96 339.257 336.905C339.19 336.849 339.145 336.772 339.131 336.687C339.117 336.591 339.141 336.494 339.198 336.416C339.255 336.337 339.339 336.283 339.435 336.265L341.429 335.918C341.477 335.909 341.527 335.91 341.574 335.921C341.622 335.931 341.667 335.951 341.707 335.98C341.747 336.008 341.78 336.043 341.806 336.085C341.831 336.126 341.848 336.172 341.856 336.219C341.864 336.267 341.863 336.316 341.853 336.363C341.842 336.41 341.822 336.455 341.793 336.494C341.765 336.534 341.729 336.567 341.687 336.592C341.646 336.618 341.599 336.634 341.551 336.642L339.557 336.988H339.496Z"
        fill="#00112B"
      />
      <path
        d="M347.578 337.539C347.538 337.556 347.494 337.562 347.45 337.556L344.499 336.531C344.42 336.502 344.355 336.444 344.318 336.367C344.281 336.291 344.274 336.203 344.3 336.122C344.328 336.046 344.385 335.983 344.458 335.949C344.531 335.914 344.615 335.91 344.691 335.937L347.643 336.962C347.713 336.982 347.774 337.026 347.816 337.087C347.857 337.148 347.876 337.222 347.869 337.296C347.862 337.37 347.829 337.438 347.777 337.49C347.725 337.541 347.656 337.572 347.583 337.578L347.578 337.539Z"
        fill="#00112B"
      />
      <path
        d="M340.873 340.936H340.766C340.72 340.925 340.677 340.908 340.639 340.884C340.602 340.86 340.571 340.831 340.548 340.798C340.525 340.765 340.511 340.729 340.507 340.691C340.502 340.654 340.507 340.616 340.521 340.581L341.087 339.146L340.582 338.672C340.551 338.643 340.528 338.61 340.513 338.574C340.499 338.538 340.493 338.5 340.498 338.463C340.502 338.425 340.516 338.389 340.538 338.356C340.56 338.322 340.591 338.293 340.628 338.269C340.665 338.245 340.708 338.226 340.755 338.215C340.801 338.204 340.849 338.2 340.898 338.203C340.946 338.206 340.993 338.217 341.036 338.234C341.079 338.252 341.117 338.275 341.148 338.304L341.775 338.897C341.814 338.933 341.841 338.975 341.854 339.02C341.867 339.066 341.866 339.113 341.852 339.158L341.225 340.747C341.197 340.802 341.149 340.849 341.086 340.883C341.024 340.917 340.949 340.936 340.873 340.936Z"
        fill="#00112B"
      />
      <path
        d="M345.743 340.927L345.652 340.923C345.614 340.911 345.578 340.892 345.548 340.869C345.517 340.845 345.492 340.817 345.475 340.785C345.457 340.753 345.447 340.719 345.445 340.684C345.442 340.649 345.448 340.614 345.462 340.582L345.992 339.269L345.403 338.62C345.351 338.564 345.327 338.492 345.336 338.421C345.346 338.35 345.388 338.285 345.454 338.241C345.519 338.198 345.603 338.178 345.686 338.188C345.77 338.197 345.846 338.234 345.898 338.291L346.599 339.055C346.629 339.092 346.65 339.135 346.659 339.179C346.668 339.224 346.665 339.269 346.651 339.312L346.048 340.765C346.023 340.816 345.98 340.858 345.925 340.887C345.871 340.916 345.807 340.93 345.743 340.927Z"
        fill="#00112B"
      />
      <path
        d="M345.39 354.681H345.309C342.311 354.681 341.266 353.461 341.231 353.414C341.209 353.389 341.193 353.36 341.185 353.331C341.176 353.301 341.175 353.27 341.182 353.239C341.188 353.209 341.202 353.18 341.223 353.155C341.243 353.129 341.27 353.107 341.301 353.089C341.331 353.071 341.365 353.059 341.402 353.052C341.438 353.045 341.476 353.044 341.513 353.049C341.55 353.055 341.585 353.066 341.616 353.083C341.648 353.099 341.675 353.121 341.696 353.147C341.696 353.147 342.625 354.205 345.32 354.224H345.39C346.315 354.268 347.241 354.148 348.104 353.87C348.967 353.591 349.745 353.163 350.386 352.613C350.406 352.586 350.433 352.563 350.465 352.545C350.498 352.527 350.534 352.515 350.572 352.51C350.61 352.504 350.649 352.505 350.687 352.512C350.725 352.52 350.76 352.533 350.791 352.553C350.822 352.572 350.847 352.596 350.866 352.624C350.885 352.652 350.896 352.683 350.899 352.714C350.903 352.746 350.898 352.778 350.886 352.808C350.873 352.838 350.853 352.866 350.827 352.889C350.141 353.502 349.297 353.981 348.356 354.291C347.415 354.601 346.402 354.734 345.39 354.681Z"
        fill="white"
      />
      <path
        d="M296.908 370.396C301.529 375.496 308.2 378.798 315.511 379.603C322.49 380.384 329.533 378.67 335.09 374.837L339.175 352.744C339.175 352.744 328.356 357.576 318.288 360.988C312.359 363 302.634 358.739 302.634 358.739L296.908 370.396Z"
        fill="#004360"
      />
      <path
        d="M318.966 367.212C318.811 367.216 318.657 367.19 318.515 367.136C318.372 367.081 318.244 367 318.141 366.898C316.875 365.735 317.915 361.436 318.033 360.96C318.047 360.914 318.076 360.872 318.116 360.84C318.156 360.808 318.205 360.786 318.259 360.779C318.309 360.773 318.361 360.781 318.407 360.801C318.453 360.821 318.491 360.853 318.516 360.893C318.773 361.313 320.993 365.049 320.167 366.612C320.081 366.778 319.949 366.922 319.785 367.032C319.62 367.142 319.427 367.214 319.224 367.241L318.966 367.212ZM318.398 361.703C318.087 363.219 317.733 365.859 318.516 366.583C318.594 366.654 318.691 366.706 318.798 366.733C318.906 366.759 319.019 366.76 319.127 366.736C319.251 366.721 319.368 366.68 319.469 366.615C319.571 366.55 319.652 366.464 319.706 366.364C320.21 365.439 319.138 363.066 318.398 361.722V361.703Z"
        fill="white"
      />
      <path
        d="M347.179 411.253L333.173 417.336L329.294 409.201L323.42 396.238L325.091 395.48L329.819 393.329L337.48 389.84L347.179 411.253Z"
        fill="#E2E2FC"
      />
      <g filter="url(#filter3_d_118_403)">
        <path
          d="M349.115 410.65L335.432 417.43L331.149 409.5L324.632 396.848L326.262 396.007L330.876 393.622L338.353 389.752L349.115 410.65Z"
          fill="#EEEEFF"
        />
      </g>
      <g filter="url(#filter4_d_118_403)">
        <path
          d="M350.45 407.84L337.94 416.598L332.515 409.401L324.172 397.872L325.657 396.794L329.861 393.744L336.671 388.795L350.45 407.84Z"
          fill="white"
        />
      </g>
      <path
        d="M353.78 389.677C353.78 389.677 340.785 391.087 339.316 392.126C337.847 393.165 333.612 400.332 334.556 401.333C335.499 402.334 336.829 401.457 336.829 401.457C336.829 401.457 335.821 402.81 336.732 403.363C337.644 403.916 339.177 403.01 339.177 403.01C339.177 403.01 338.298 404.087 340.067 404.04C341.836 403.992 345.288 401.123 345.288 401.123C347.772 401.617 350.371 401.32 352.633 400.285C356.654 398.55 357.555 397.177 357.555 397.177L353.78 389.677Z"
        fill="#F7C689"
      />
      <path
        d="M336.792 401.686H336.664C336.607 401.653 336.567 401.603 336.549 401.545C336.531 401.487 336.538 401.425 336.567 401.372L339.912 396.272C339.946 396.219 340.003 396.18 340.069 396.164C340.136 396.148 340.206 396.156 340.266 396.187C340.326 396.217 340.37 396.267 340.388 396.326C340.406 396.385 340.397 396.448 340.363 396.501L337.017 401.6C336.992 401.632 336.958 401.656 336.918 401.671C336.879 401.686 336.835 401.691 336.792 401.686Z"
        fill="#00112B"
      />
      <path
        d="M339.172 403.268H339.044C338.986 403.236 338.943 403.186 338.925 403.128C338.908 403.069 338.915 403.007 338.947 402.953L342.164 397.807C342.198 397.753 342.254 397.715 342.321 397.699C342.387 397.682 342.458 397.69 342.518 397.721C342.577 397.751 342.621 397.801 342.639 397.86C342.657 397.919 342.648 397.982 342.614 398.035L339.344 403.182C339.324 403.207 339.298 403.227 339.269 403.242C339.239 403.256 339.206 403.265 339.172 403.268Z"
        fill="#00112B"
      />
      <path
        d="M351.397 352.506C351.397 352.506 379.435 355.365 379.049 381.328C378.802 397.245 354.667 402.01 354.667 402.01L347.215 385.617L359.663 379.288L351.397 352.506Z"
        fill="#004360"
      />
      <path
        d="M350.729 384.073C350.689 384.074 350.65 384.067 350.615 384.052C350.58 384.037 350.549 384.015 350.525 383.987C350.501 383.966 350.482 383.94 350.469 383.913C350.456 383.885 350.449 383.855 350.449 383.825C350.449 383.795 350.456 383.765 350.469 383.737C350.482 383.709 350.501 383.684 350.525 383.663C350.847 383.444 358.373 378.364 361.386 377.42C361.418 377.409 361.452 377.404 361.486 377.405C361.52 377.406 361.553 377.413 361.584 377.425C361.615 377.438 361.643 377.455 361.666 377.477C361.689 377.499 361.707 377.525 361.719 377.553C361.732 377.582 361.739 377.613 361.738 377.644C361.737 377.675 361.728 377.705 361.713 377.733C361.698 377.761 361.676 377.786 361.65 377.806C361.623 377.826 361.592 377.84 361.558 377.849C358.62 378.802 350.922 383.977 350.836 384.025C350.806 384.05 350.769 384.067 350.729 384.073Z"
        fill="white"
      />
      <g filter="url(#filter5_d_118_403)">
        <path
          d="M295.478 367.386L279.285 372.279L276.023 363.455L271.145 349.424C271.145 349.424 272.87 349.141 273.964 348.907C276.005 348.469 277.13 348.128 279.118 347.495C282.442 346.436 287.424 344.208 287.424 344.208L295.478 367.386Z"
          fill="white"
        />
      </g>
      <path
        d="M274.643 352.884C274.643 352.884 278.54 351.921 280.978 351.108C283.401 350.3 287.074 348.741 287.074 348.741L287.779 350.855C287.779 350.855 284.105 352.414 281.682 353.222C279.245 354.035 275.347 354.998 275.347 354.998L274.643 352.884Z"
        fill="#DBDBFF"
      />
      <path
        d="M277.227 360.089C277.227 360.089 281.168 359.256 283.605 358.443C286.028 357.634 289.658 355.946 289.658 355.946L290.665 358.966C290.665 358.966 287.034 360.654 284.611 361.462C282.174 362.275 278.233 363.109 278.233 363.109L277.227 360.089Z"
        fill="#DBDBFF"
      />
      <path
        d="M357.635 379.602H357.538C357.492 379.585 357.452 379.555 357.424 379.518C357.395 379.481 357.379 379.438 357.377 379.393C357.377 378.973 357.313 375.323 358.632 374.561C358.795 374.477 358.98 374.433 359.168 374.433C359.356 374.433 359.541 374.477 359.704 374.561C359.895 374.633 360.062 374.746 360.189 374.891C360.317 375.036 360.401 375.208 360.433 375.39C360.733 376.848 358.107 379.288 357.796 379.564C357.749 379.595 357.692 379.609 357.635 379.602ZM359.168 374.837C359.076 374.833 358.986 374.856 358.911 374.904C358.139 375.352 357.924 377.468 357.839 378.716C358.728 377.82 360.069 376.248 359.897 375.371C359.85 375.216 359.749 375.078 359.608 374.977C359.468 374.876 359.295 374.817 359.114 374.808L359.168 374.837Z"
        fill="white"
      />
      <path
        d="M342.748 345.713C342.991 345.802 343.255 345.832 343.51 345.801C343.795 345.75 344.057 345.638 344.273 345.477C344.488 345.316 344.724 344.992 344.819 344.759C344.838 344.723 344.844 344.682 344.836 344.642C344.829 344.601 344.809 344.563 344.778 344.53C344.75 344.498 344.711 344.473 344.667 344.458C344.624 344.444 344.576 344.44 344.531 344.447L342.114 344.957C342.071 344.967 342.032 344.985 342 345.01C341.969 345.035 341.945 345.066 341.931 345.102C341.92 345.138 341.921 345.176 341.934 345.213C341.946 345.25 341.969 345.284 342.001 345.313C342.222 345.482 342.475 345.618 342.748 345.713ZM343.997 345.085C343.855 345.24 343.652 345.347 343.422 345.388C343.207 345.407 342.987 345.369 342.792 345.279L343.997 345.085Z"
        fill="white"
      />
      <path
        d="M295.15 360.664C295.15 360.664 286.165 359.816 286.776 357.986C287.387 356.156 295.493 354.812 296.608 355.346C297.727 356.065 298.74 356.908 299.621 357.853L295.15 360.664Z"
        fill="#F7C689"
      />
      <path
        d="M345.81 344.237L341.393 345.071C341.393 345.071 342.269 346.661 343.489 346.431C344.709 346.201 345.81 344.237 345.81 344.237Z"
        fill="white"
      />
      <g filter="url(#filter6_d_118_403)">
        <path
          d="M367.593 494.797C367.123 495.589 361.163 495.045 360.652 495.189C360.14 495.332 358.564 492.259 357.615 492.756C356.665 493.252 355.527 494.74 354.118 495.456C352.709 496.171 330.832 496.667 326.563 496.267C326.477 496.256 326.393 496.23 326.318 496.19C326.243 496.149 326.178 496.095 326.126 496.031C326.075 495.967 326.038 495.894 326.018 495.816C325.998 495.739 325.995 495.658 326.01 495.58C326.197 494.324 326.504 493.085 326.928 491.878L367.634 491C367.778 492.263 367.764 493.537 367.593 494.797Z"
          fill="#4F5B94"
        />
      </g>
      <path
        d="M104.436 439.925L115.553 445.946L121.055 430.34L114.717 426.766L104.436 439.925Z"
        fill="#F19551"
      />
      <path
        d="M102.885 417.067C101.893 416.997 99.037 422.151 98.632 422.499C98.227 422.848 100.168 425.818 99.178 426.324C98.188 426.83 96.164 426.928 94.709 427.674C93.254 428.421 80.513 445.97 78.486 449.67C78.447 449.746 78.424 449.828 78.418 449.912C78.413 449.996 78.426 450.079 78.456 450.157C78.485 450.235 78.532 450.306 78.592 450.366C78.652 450.426 78.725 450.473 78.806 450.505C80.074 451.049 81.393 451.485 82.748 451.809C84.586 452.33 86.557 452.351 88.438 451.87C92.555 450.515 97.6 445.357 100.529 444.198C103.458 443.04 108.562 442.909 108.837 441.255C109.111 439.601 107.85 435.329 110.764 432.281C113.678 429.233 115.658 428.179 115.481 426.732C115.361 425.733 110.098 421.705 106.393 419.169C105.319 418.338 104.141 417.633 102.885 417.067Z"
        fill="#273754"
      />
      <g filter="url(#filter7_d_118_403)">
        <path
          d="M102.062 416.156C101.06 416.086 98.2067 421.34 97.7997 421.695C97.3927 422.051 99.3707 425.075 98.3737 425.592C97.3777 426.109 95.3347 426.21 93.8697 426.972C92.4047 427.734 79.6467 445.628 77.6217 449.4C77.5827 449.477 77.5597 449.561 77.5547 449.647C77.5497 449.732 77.5637 449.817 77.5937 449.897C77.6247 449.976 77.6717 450.049 77.7327 450.11C77.7947 450.17 77.8677 450.219 77.9497 450.251C79.2337 450.804 80.5677 451.247 81.9377 451.575L105.616 418.294C104.527 417.449 103.334 416.731 102.062 416.156Z"
          fill="white"
        />
      </g>
      <path
        d="M171.219 473.699L171.485 479.158L161.68 482.781L156.496 482.362L156.602 471.094L171.219 473.699Z"
        fill="#F19551"
      />
      <path
        d="M153.613 391.407C153.613 391.407 149.647 400.063 147.012 407.572C144.378 415.081 140.626 425.109 140.626 425.109C140.626 425.109 128.576 447.421 144.243 452.714C163.668 459.288 167.67 436.799 167.67 436.799L172.163 388.966L153.613 391.407Z"
        fill="#526181"
      />
      <path
        d="M183.35 389.989C183.35 389.989 189.511 415.737 187.472 434.598C185.432 453.46 177.911 475.516 177.911 475.516L152.99 474.917L157.728 444.179L163.794 391.605L183.35 389.989Z"
        fill="#526181"
      />
      <path
        d="M153.41 494.507C153.888 495.336 159.954 494.767 160.474 494.916C160.995 495.066 162.599 491.853 163.565 492.372C164.532 492.89 165.69 494.447 167.124 495.196C168.558 495.944 190.824 496.463 195.168 496.044C195.256 496.033 195.341 496.006 195.417 495.963C195.494 495.921 195.56 495.865 195.613 495.797C195.665 495.73 195.703 495.654 195.723 495.573C195.744 495.492 195.746 495.408 195.731 495.326C195.541 494.012 195.228 492.716 194.796 491.453C194.277 489.694 193.247 488.105 191.822 486.863C188.444 484.318 181.199 483.13 178.639 481.424C176.079 479.717 173.232 475.695 171.628 476.434C170.024 477.172 166.943 480.426 162.673 479.847C158.403 479.268 156.459 478.19 155.237 479.128C154.44 479.767 153.665 486.214 153.399 490.575C153.246 491.882 153.25 493.201 153.41 494.507Z"
        fill="#273754"
      />
      <path
        d="M151.481 426.804C151.369 426.806 151.257 426.789 151.151 426.754C148.942 426.115 146.201 418.83 145.84 418.002C145.823 417.952 145.824 417.898 145.843 417.848C145.862 417.799 145.898 417.757 145.945 417.728C145.993 417.7 146.048 417.687 146.104 417.691C146.16 417.696 146.213 417.717 146.254 417.752C146.52 417.982 152.628 423.401 152.522 425.736C152.518 425.902 152.473 426.064 152.392 426.211C152.311 426.358 152.196 426.486 152.054 426.585C151.89 426.71 151.691 426.786 151.481 426.804ZM146.753 418.82C147.816 421.405 149.845 425.876 151.3 426.295C151.384 426.323 151.473 426.33 151.561 426.316C151.648 426.302 151.73 426.267 151.799 426.215C151.881 426.159 151.948 426.085 151.994 426C152.04 425.916 152.064 425.822 152.065 425.726C152.15 424.189 148.772 420.706 146.753 418.82Z"
        fill="#00112B"
      />
      <path
        d="M151.343 403.052C151.303 403.054 151.263 403.047 151.226 403.032C151.189 403.016 151.156 402.992 151.131 402.963C151.102 402.906 151.097 402.84 151.119 402.78C151.141 402.72 151.187 402.671 151.248 402.643C154.764 401.007 157.09 396.795 157.112 396.755C157.127 396.727 157.149 396.701 157.175 396.681C157.201 396.66 157.232 396.645 157.264 396.636C157.297 396.626 157.331 396.623 157.365 396.627C157.399 396.63 157.432 396.64 157.462 396.655C157.492 396.669 157.519 396.688 157.541 396.712C157.563 396.736 157.579 396.764 157.589 396.793C157.599 396.823 157.602 396.855 157.599 396.886C157.595 396.917 157.585 396.947 157.568 396.975C157.473 397.154 155.146 401.366 151.471 403.072C151.427 403.079 151.382 403.072 151.343 403.052Z"
        fill="#00112B"
      />
      <g filter="url(#filter8_d_118_403)">
        <path
          d="M153.39 494.507C153.868 495.335 159.934 494.767 160.454 494.916C160.975 495.066 162.579 491.852 163.546 492.371C164.512 492.89 165.67 494.447 167.104 495.196C168.538 495.944 190.804 496.463 195.148 496.044C195.236 496.033 195.321 496.006 195.397 495.963C195.474 495.921 195.54 495.864 195.593 495.797C195.645 495.73 195.683 495.654 195.703 495.573C195.724 495.492 195.727 495.408 195.711 495.325C195.521 494.011 195.209 492.716 194.777 491.453L153.348 490.535C153.202 491.856 153.216 493.189 153.39 494.507Z"
          fill="white"
        />
      </g>
      <path
        d="M224.637 376.77C224.637 376.77 213.195 375.866 212.68 372.12C212.344 370.026 210.998 368.415 211.606 366.714C211.606 366.714 221.005 358.962 223.409 361.826C227.175 366.26 224.637 376.77 224.637 376.77Z"
        fill="#F19551"
      />
      <path
        d="M231.141 371.323C231.141 371.323 237.238 371.312 235.901 368.999C234.565 366.687 224.506 364.785 223.243 367.266C221.98 369.747 231.141 371.323 231.141 371.323Z"
        fill="#F19551"
      />
      <path
        d="M227.622 374.542C227.622 374.542 231.946 374.537 231.293 372.198C229.965 369.883 221.06 367.934 219.888 370.373C218.717 372.812 227.622 374.542 227.622 374.542Z"
        fill="#F19551"
      />
      <path
        d="M225.859 377.732C225.859 377.732 229.557 378.101 228.742 375.9C227.927 373.698 221.171 371.06 219.751 373.004C218.33 374.949 225.859 377.732 225.859 377.732Z"
        fill="#F19551"
      />
      <path
        d="M216.732 369.674C216.715 369.643 216.705 369.609 216.702 369.574C216.699 369.539 216.704 369.504 216.716 369.472C216.728 369.439 216.748 369.41 216.773 369.385C216.798 369.36 216.828 369.341 216.862 369.328C219.355 368.491 220.374 365.657 220.382 365.629C220.4 365.567 220.444 365.514 220.504 365.483C220.564 365.452 220.635 365.444 220.702 365.462C220.765 365.484 220.817 365.527 220.85 365.582C220.883 365.637 220.895 365.701 220.882 365.762C220.838 365.889 219.784 368.845 217.05 369.762C216.995 369.784 216.934 369.786 216.876 369.77C216.819 369.754 216.768 369.72 216.732 369.674Z"
        fill="#011533"
      />
      <path
        d="M221.443 367.055C221.443 367.055 230.484 365.483 230.226 363.489C229.968 361.495 222.248 360.955 221.083 361.32C219.853 361.85 218.703 362.528 217.661 363.337L221.443 367.055Z"
        fill="#F19551"
      />
      <path
        d="M217.665 379.297C217.665 379.297 201.176 389.662 188.476 385.957C174.472 381.861 172.046 373.278 172.046 373.278L179.27 354.735C179.27 354.735 190.078 363.278 197.069 364.109C200.784 364.533 210.191 362.742 210.191 362.742L217.665 379.297Z"
        fill="#C8C8F1"
      />
      <path
        d="M138.206 396.873C137.951 397.981 135.827 399.987 135.827 399.987C135.827 399.987 134.626 403.919 133.309 404.038C131.992 404.158 130.876 402.152 130.876 402.152C130.876 402.152 128.114 402.931 127.137 402.631C126.16 402.332 121.475 401.364 120.647 398.919C119.818 396.474 125.384 387.063 125.384 387.063L135.954 387.452C135.954 387.452 138.482 395.805 138.206 396.873Z"
        fill="#F19551"
      />
      <path
        d="M130.857 402.432C130.822 402.43 130.786 402.422 130.754 402.408C130.721 402.394 130.692 402.373 130.669 402.348C130.645 402.323 130.627 402.293 130.615 402.261C130.604 402.23 130.6 402.196 130.602 402.162L131.017 399.278C131.027 399.215 131.063 399.159 131.116 399.12C131.169 399.081 131.236 399.063 131.304 399.068C131.337 399.072 131.37 399.082 131.399 399.098C131.429 399.113 131.454 399.134 131.475 399.159C131.496 399.184 131.511 399.213 131.52 399.244C131.529 399.274 131.531 399.306 131.527 399.338L131.112 402.222C131.102 402.279 131.072 402.332 131.025 402.37C130.978 402.408 130.919 402.43 130.857 402.432Z"
        fill="#011533"
      />
      <path
        d="M135.835 400.266C135.8 400.265 135.766 400.257 135.734 400.243C135.703 400.23 135.674 400.21 135.651 400.186C135.627 400.162 135.608 400.134 135.596 400.103C135.584 400.072 135.579 400.039 135.58 400.007L136.186 393.44C136.187 393.409 136.195 393.378 136.209 393.35C136.224 393.322 136.244 393.297 136.269 393.277C136.293 393.256 136.322 393.241 136.354 393.231C136.385 393.221 136.418 393.218 136.451 393.22C136.485 393.223 136.518 393.232 136.547 393.246C136.577 393.26 136.604 393.28 136.626 393.304C136.647 393.329 136.664 393.356 136.674 393.387C136.684 393.417 136.688 393.448 136.685 393.48L136.09 400.047C136.083 400.106 136.053 400.16 136.006 400.201C135.959 400.241 135.899 400.264 135.835 400.266Z"
        fill="#011533"
      />
      <path
        d="M157.941 351.056L172.154 352.842L179.08 393.16C179.08 393.16 170.497 394.817 163.783 394.208C157.07 393.6 155.285 392.711 155.285 392.711L157.941 351.056Z"
        fill="#273754"
      />
      <path
        d="M169.158 351.056C169.261 351.296 169.346 351.543 169.413 351.794C169.413 351.794 171.251 357.263 173.418 372.562C174.82 382.462 175.543 391.404 175.999 395.466L185.007 394.348C185.007 394.348 181.651 357.952 179.239 354.958C177.423 352.692 171.782 351.495 169.158 351.056Z"
        fill="#C8C8F1"
      />
      <path
        d="M119.346 388.001L139.816 389.997C139.816 389.997 141.059 382.791 143.343 379.468C143.924 378.593 144.689 377.837 145.591 377.249C146.493 376.66 147.514 376.251 148.59 376.045V395.466H162.081L160.18 353.241L160.339 350.088C153.232 349.868 142.28 350.916 133.41 357.802C119.526 368.6 119.346 388.001 119.346 388.001Z"
        fill="#C8C8F1"
      />
      <path
        d="M194.68 370.149C194.366 370.044 194.101 369.829 193.943 369.547C193.076 367.984 195.148 364.337 195.39 363.924C195.416 363.886 195.452 363.856 195.495 363.835C195.537 363.815 195.585 363.805 195.633 363.807C195.681 363.816 195.727 363.837 195.765 363.867C195.804 363.897 195.835 363.935 195.855 363.978C196.013 364.433 197.417 368.492 196.296 369.827C196.149 369.999 195.953 370.127 195.731 370.197C195.509 370.268 195.268 370.279 195.035 370.228C194.915 370.213 194.796 370.186 194.68 370.149ZM195.558 364.678C194.878 365.975 193.861 368.316 194.388 369.331C194.46 369.457 194.566 369.563 194.694 369.639C194.823 369.714 194.969 369.756 195.117 369.76C195.261 369.791 195.41 369.784 195.548 369.74C195.686 369.696 195.807 369.617 195.899 369.512C196.601 368.676 196.007 366.088 195.548 364.675L195.558 364.678Z"
        fill="white"
      />
      <path
        d="M143.356 379.708C143.318 379.718 143.278 379.718 143.239 379.708C142.485 379.369 138.682 377.572 138.608 376.265C138.603 376.116 138.642 375.97 138.721 375.841C138.799 375.712 138.915 375.607 139.054 375.536C139.21 375.442 139.386 375.381 139.57 375.358C139.753 375.336 139.94 375.352 140.116 375.407C141.795 375.866 143.505 379.249 143.579 379.398C143.611 379.437 143.629 379.484 143.629 379.533C143.629 379.582 143.611 379.629 143.579 379.668C143.548 379.69 143.511 379.706 143.473 379.713C143.434 379.719 143.394 379.718 143.356 379.708ZM139.723 375.796C139.579 375.797 139.438 375.839 139.32 375.916C139.128 376.025 139.107 376.135 139.118 376.205C139.118 376.903 141.157 378.121 142.772 378.919C142.124 377.802 140.966 376.105 139.978 375.836C139.896 375.809 139.81 375.795 139.723 375.796Z"
        fill="white"
      />
      <path
        d="M182.347 373.41C182.285 373.409 182.226 373.387 182.179 373.349C182.133 373.31 182.102 373.258 182.092 373.201L180.892 363.321C180.886 363.259 180.906 363.197 180.947 363.148C180.989 363.1 181.049 363.069 181.115 363.061C181.148 363.057 181.182 363.059 181.215 363.067C181.248 363.076 181.278 363.09 181.305 363.11C181.332 363.129 181.354 363.153 181.37 363.181C181.387 363.209 181.398 363.239 181.402 363.271L182.602 373.141C182.608 373.204 182.589 373.267 182.547 373.317C182.506 373.367 182.446 373.4 182.379 373.41H182.347Z"
        fill="white"
      />
      <path
        d="M148.606 376.285C148.538 376.285 148.473 376.26 148.426 376.215C148.378 376.17 148.351 376.109 148.351 376.046V373.381C148.343 373.346 148.344 373.31 148.353 373.276C148.362 373.241 148.379 373.209 148.403 373.181C148.427 373.154 148.457 373.131 148.491 373.116C148.525 373.101 148.563 373.093 148.601 373.093C148.639 373.093 148.676 373.101 148.71 373.116C148.744 373.131 148.774 373.154 148.798 373.181C148.822 373.209 148.839 373.241 148.848 373.276C148.857 373.31 148.858 373.346 148.85 373.381V376.046C148.852 376.077 148.846 376.107 148.835 376.136C148.823 376.165 148.805 376.192 148.783 376.214C148.76 376.237 148.732 376.255 148.702 376.267C148.672 376.279 148.639 376.285 148.606 376.285Z"
        fill="white"
      />
      <path
        d="M225.243 370.677C225.2 370.646 225.169 370.602 225.155 370.552C225.171 370.491 225.211 370.438 225.267 370.403C225.322 370.369 225.39 370.356 225.456 370.366L230.319 370.687C230.384 370.702 230.44 370.74 230.477 370.793C230.514 370.846 230.529 370.91 230.518 370.972C230.516 371.004 230.508 371.035 230.493 371.064C230.479 371.093 230.458 371.118 230.433 371.139C230.408 371.161 230.378 371.177 230.346 371.187C230.314 371.197 230.28 371.201 230.246 371.199L225.378 370.87C225.339 370.851 225.307 370.824 225.283 370.79C225.259 370.757 225.245 370.718 225.243 370.677Z"
        fill="#011533"
      />
      <path
        d="M224.141 373.462C224.107 373.427 224.083 373.382 224.075 373.335C224.091 373.282 224.128 373.24 224.177 373.218C224.226 373.195 224.283 373.194 224.338 373.214L228.406 374.269C228.46 374.293 228.505 374.336 228.533 374.39C228.561 374.443 228.57 374.503 228.557 374.558C228.554 374.586 228.545 374.614 228.532 374.637C228.518 374.661 228.499 374.681 228.476 374.697C228.454 374.712 228.428 374.722 228.401 374.726C228.373 374.73 228.344 374.728 228.316 374.721L224.244 373.658C224.212 373.635 224.186 373.605 224.169 373.571C224.151 373.536 224.141 373.499 224.141 373.462Z"
        fill="#011533"
      />
      <path
        d="M158.686 345.575L159.422 352.655C159.422 352.655 160.986 354.561 165.429 354.487C168.738 354.487 169.814 353.635 169.814 353.635L168.987 350.1L168.171 346.651L160.023 345.735L158.686 345.575Z"
        fill="#F19551"
      />
      <path
        d="M160.029 345.735C160.093 345.967 160.193 346.189 160.324 346.395C162.375 349.77 167.056 350.11 168.971 350.1L168.155 346.65L160.029 345.735Z"
        fill="#B96248"
      />
      <path
        d="M167.736 331.064C167.736 331.064 172.439 339.389 171.431 344.351C170.422 349.312 165.764 348.908 162.863 348.194C161.248 347.829 159.767 347.06 158.579 345.969C157.813 346.259 156.968 346.313 156.167 346.121C155.366 345.93 154.651 345.504 154.125 344.904C152.187 342.775 152.992 340.028 154.454 339.304C154.981 339.113 155.545 339.028 156.11 339.055C156.674 339.083 157.226 339.222 157.729 339.464L156.143 337.058C156.143 337.058 160.846 323.802 167.736 331.064Z"
        fill="#F19551"
      />
      <path
        d="M168.989 338.521C169.334 338.521 169.614 338.121 169.614 337.629C169.614 337.137 169.334 336.737 168.989 336.737C168.643 336.737 168.363 337.137 168.363 337.629C168.363 338.121 168.643 338.521 168.989 338.521Z"
        fill="#011533"
      />
      <path
        d="M164.485 339.413C164.83 339.413 165.11 339.014 165.11 338.521C165.11 338.029 164.83 337.629 164.485 337.629C164.139 337.629 163.859 338.029 163.859 338.521C163.859 339.014 164.139 339.413 164.485 339.413Z"
        fill="#011533"
      />
      <path
        d="M168.236 344.52C167.903 344.704 167.526 344.808 167.148 344.82C166.722 344.81 166.316 344.707 165.967 344.522C165.617 344.336 165.201 343.918 165.01 343.602C164.975 343.553 164.957 343.495 164.958 343.435C164.96 343.375 164.98 343.314 165.017 343.26C165.052 343.207 165.102 343.162 165.162 343.13C165.223 343.099 165.291 343.083 165.358 343.083L168.986 343.278C169.05 343.282 169.111 343.299 169.163 343.328C169.215 343.357 169.257 343.398 169.285 343.446C169.308 343.497 169.315 343.553 169.306 343.609C169.296 343.666 169.27 343.721 169.231 343.769C168.948 344.065 168.611 344.319 168.236 344.52ZM166.279 343.889C166.52 344.083 166.839 344.192 167.183 344.199C167.499 344.179 167.811 344.074 168.074 343.898L166.279 343.889Z"
        fill="#1D2943"
      />
      <path
        d="M157.854 343.148C157.809 343.158 157.763 343.158 157.718 343.148L154.216 341.21C154.18 341.196 154.148 341.175 154.121 341.149C154.094 341.122 154.074 341.09 154.061 341.056C154.049 341.021 154.044 340.984 154.048 340.948C154.052 340.911 154.064 340.876 154.084 340.844C154.104 340.813 154.131 340.786 154.162 340.764C154.194 340.743 154.231 340.729 154.269 340.722C154.307 340.716 154.347 340.717 154.385 340.726C154.423 340.734 154.458 340.751 154.488 340.774L157.99 342.711C158.021 342.727 158.049 342.748 158.071 342.774C158.093 342.8 158.109 342.829 158.119 342.861C158.128 342.893 158.131 342.926 158.126 342.959C158.122 342.992 158.11 343.024 158.092 343.052C158.063 343.085 158.027 343.11 157.986 343.127C157.944 343.144 157.899 343.151 157.854 343.148Z"
        fill="#011533"
      />
      <path
        d="M154.847 343.393C154.78 343.396 154.715 343.376 154.663 343.337C154.611 343.298 154.576 343.242 154.564 343.18C154.553 343.118 154.567 343.055 154.602 343.002C154.637 342.949 154.692 342.91 154.756 342.892L156.864 342.168C156.897 342.156 156.932 342.151 156.967 342.152C157.002 342.153 157.036 342.161 157.068 342.175C157.099 342.189 157.128 342.209 157.151 342.233C157.175 342.257 157.193 342.286 157.204 342.317C157.217 342.349 157.223 342.382 157.222 342.416C157.221 342.449 157.212 342.483 157.198 342.513C157.183 342.544 157.162 342.571 157.136 342.594C157.11 342.617 157.079 342.635 157.045 342.647L154.949 343.371L154.847 343.393Z"
        fill="#011533"
      />
      <path
        d="M162.586 336.859C162.552 336.862 162.517 336.855 162.486 336.839C162.427 336.8 162.385 336.742 162.371 336.676C162.356 336.61 162.369 336.542 162.407 336.486C162.68 336.053 163.11 335.73 163.62 335.576C164.13 335.421 164.687 335.446 165.188 335.644C165.221 335.658 165.251 335.678 165.275 335.704C165.299 335.729 165.318 335.758 165.33 335.79C165.342 335.822 165.347 335.856 165.345 335.889C165.342 335.923 165.333 335.955 165.316 335.985C165.304 336.015 165.284 336.043 165.259 336.066C165.234 336.089 165.205 336.107 165.172 336.119C165.14 336.13 165.105 336.136 165.07 336.134C165.034 336.133 165 336.125 164.968 336.11C164.585 335.958 164.159 335.941 163.771 336.063C163.383 336.184 163.058 336.437 162.858 336.772C162.827 336.81 162.784 336.838 162.736 336.853C162.688 336.868 162.636 336.87 162.586 336.859Z"
        fill="#011533"
      />
      <path
        d="M169.21 335.099C169.166 335.122 169.115 335.133 169.066 335.129C168.173 334.795 167.855 335.318 167.846 335.386C167.811 335.446 167.752 335.492 167.683 335.513C167.613 335.534 167.539 335.528 167.475 335.496C167.412 335.465 167.365 335.411 167.345 335.346C167.324 335.28 167.333 335.21 167.367 335.149C167.578 334.861 167.896 334.658 168.256 334.583C168.615 334.507 168.988 334.564 169.297 334.743C169.362 334.769 169.412 334.818 169.438 334.879C169.464 334.941 169.463 335.01 169.436 335.073C169.402 335.093 169.365 335.106 169.325 335.11C169.286 335.115 169.247 335.111 169.21 335.099Z"
        fill="#011533"
      />
      <path
        d="M168.729 332.969C168.417 332.57 168.001 332.254 167.52 332.051C167.04 331.847 166.512 331.764 165.987 331.809C165.445 331.863 164.921 332.021 164.447 332.274C163.973 332.527 163.56 332.869 163.233 333.278C163.233 333.278 164.366 336.121 162.02 337.888C160.869 338.904 159.338 339.451 157.759 339.411L155.912 338.974L154.359 336.6L158.983 330.808L165.08 327.784L168.786 330.425L168.729 332.969Z"
        fill="#011533"
      />
      <path
        d="M169.573 334.833C169.104 333.9 168.505 333.031 167.794 332.246C166.558 330.861 161.561 332.597 159.929 335.44C159.083 336.845 158.359 338.312 157.764 339.826C156.847 339.47 155.851 339.331 154.863 339.421C153.514 339.698 153.367 340.486 153.367 340.486C152.628 339.364 151.962 338.202 151.372 337.005L151.202 336.387C151.202 336.387 150.715 336.76 149.888 335.791C149.06 334.822 149.083 328.7 155.917 325.868C162.75 323.036 167.442 327.87 169.097 329.861C170.751 331.852 169.573 334.833 169.573 334.833Z"
        fill="#004360"
      />
      <path
        d="M151.204 336.547H151.113C151.08 336.536 151.05 336.519 151.024 336.497C150.998 336.475 150.977 336.449 150.962 336.419C150.947 336.389 150.939 336.357 150.938 336.324C150.936 336.291 150.942 336.258 150.955 336.227L151.521 334.769C151.533 334.738 151.551 334.709 151.574 334.685C151.598 334.66 151.626 334.64 151.658 334.626C151.69 334.613 151.724 334.605 151.759 334.604C151.794 334.603 151.829 334.608 151.861 334.62C151.896 334.629 151.927 334.645 151.954 334.667C151.981 334.689 152.003 334.715 152.018 334.746C152.033 334.776 152.041 334.809 152.041 334.842C152.042 334.876 152.034 334.909 152.02 334.939L151.465 336.387C151.443 336.435 151.406 336.475 151.36 336.504C151.314 336.532 151.259 336.547 151.204 336.547Z"
        fill="white"
      />
      <path
        d="M112.184 449.201L119.141 425.114L139.242 430.111L155.623 452.901C155.623 452.901 143.849 461.234 112.184 449.201Z"
        fill="#526181"
      />
      <path
        d="M150.206 408.093C157.981 409.719 161.295 416.859 161.925 422.732C162.541 428.944 160.605 435.234 156.409 440.651C154.075 443.688 151.045 446.357 147.487 448.51C147.145 448.713 147.533 449.121 147.875 448.914C154.419 444.989 159.077 439.266 161.289 433.061C163.501 426.856 163.318 419.945 159.808 414.309C157.883 411.234 154.794 408.501 150.494 407.603C150.098 407.521 149.829 408.005 150.229 408.087L150.206 408.093Z"
        fill="#00112B"
      />
      <path
        d="M164.224 397.637C162.438 401.311 165.205 405.344 167.502 408.203C170.103 411.418 173.416 414.23 177.518 415.576C179.795 416.348 182.24 416.581 184.636 416.254C184.706 416.237 184.767 416.197 184.808 416.141C184.848 416.085 184.865 416.017 184.856 415.95C184.847 415.883 184.812 415.821 184.757 415.776C184.703 415.732 184.633 415.708 184.561 415.708C180.44 416.313 176.288 414.981 172.992 412.665C171.366 411.506 169.899 410.161 168.626 408.661C167.326 407.205 166.213 405.61 165.308 403.91C164.354 402.001 163.795 399.833 164.761 397.843C164.919 397.52 164.377 397.307 164.223 397.629L164.224 397.637Z"
        fill="#00112B"
      />
      <path
        d="M183.113 424C179.523 425.476 177.273 428.976 176.886 432.564C176.397 437.1 178.528 441.466 181.345 445.027C183.075 447.122 184.944 449.113 186.939 450.988C187.194 451.24 187.66 450.9 187.401 450.648C184.19 447.512 180.912 444.266 178.976 440.249C177.216 436.571 176.699 432.275 178.762 428.608C179.751 426.798 181.36 425.354 183.33 424.509C183.402 424.481 183.459 424.427 183.488 424.36C183.518 424.292 183.517 424.216 183.487 424.149C183.458 424.082 183.4 424.029 183.329 424.001C183.257 423.973 183.176 423.973 183.105 424.001L183.113 424Z"
        fill="#00112B"
      />
      <path
        d="M152.606 456.942C154.806 455.948 157.588 456.572 159.803 457.249C161.905 457.908 163.892 458.853 165.702 460.053C169.577 462.598 172.576 466.1 174.962 469.909C176.369 472.211 177.622 474.594 178.714 477.042C178.743 477.11 178.801 477.163 178.872 477.191C178.944 477.218 179.025 477.218 179.096 477.19C179.168 477.162 179.225 477.108 179.254 477.041C179.284 476.973 179.283 476.898 179.253 476.831C175.476 468.546 169.913 459.944 160.348 456.859C157.915 456.07 154.822 455.346 152.383 456.45C152.042 456.605 152.268 457.113 152.609 456.958L152.606 456.942Z"
        fill="#00112B"
      />
      <path
        d="M163.409 451.513C164.906 451.331 164.604 449.147 163.107 449.33C161.61 449.513 161.912 451.696 163.409 451.513Z"
        fill="#00112B"
      />
      <path
        d="M180.616 403.052C182.108 402.87 181.811 400.69 180.314 400.873C178.817 401.056 179.119 403.235 180.616 403.052Z"
        fill="#00112B"
      />
      <path
        d="M147.809 437.665C145.892 433.705 140.446 433.093 136.348 432.925C131.727 432.75 126.951 433.417 122.886 435.724C120.607 436.988 118.677 438.758 117.266 440.879C117.232 440.945 117.223 441.021 117.243 441.092C117.263 441.163 117.31 441.224 117.375 441.263C117.439 441.302 117.518 441.317 117.594 441.305C117.671 441.293 117.742 441.255 117.792 441.197C120.182 437.522 124.27 435.166 128.604 434.168C130.758 433.687 132.958 433.461 135.156 433.496C137.336 433.479 139.503 433.705 141.614 434.17C143.941 434.74 146.212 435.802 147.251 437.946C147.419 438.295 147.987 438.014 147.816 437.669L147.809 437.665Z"
        fill="#00112B"
      />
      <path
        d="M136.278 439.137C135.462 440.325 137.425 441.52 138.243 440.329C139.062 439.137 137.097 437.945 136.278 439.137Z"
        fill="#00112B"
      />
      <path
        d="M173.112 423.768C174.609 423.585 174.307 421.402 172.81 421.585C171.313 421.768 171.615 423.951 173.112 423.768Z"
        fill="#00112B"
      />
      <path
        d="M160.604 408.464C162.097 408.282 161.799 406.102 160.302 406.285C158.805 406.468 159.107 408.647 160.604 408.464Z"
        fill="#00112B"
      />
      <path
        d="M181.345 456.126C182.837 455.943 182.539 453.76 181.043 453.942C179.546 454.125 179.848 456.308 181.345 456.126Z"
        fill="#00112B"
      />
      <path
        d="M161.532 471.819C163.029 471.636 162.727 469.453 161.23 469.636C159.733 469.819 160.035 472.002 161.532 471.819Z"
        fill="#00112B"
      />
      <path
        d="M142.968 455.545C142.492 455.492 142.02 455.407 141.557 455.29C141.525 455.282 141.494 455.268 141.467 455.249C141.44 455.229 141.418 455.205 141.401 455.178C141.384 455.15 141.373 455.12 141.369 455.088C141.364 455.057 141.367 455.025 141.376 454.994C141.395 454.934 141.439 454.882 141.497 454.85C141.556 454.819 141.625 454.809 141.691 454.824C144.678 455.446 147.785 455.344 150.72 454.529C153.654 453.713 156.32 452.21 158.467 450.161C168.785 440.364 167.212 408.35 167.196 408.026C167.197 407.958 167.226 407.893 167.276 407.845C167.301 407.821 167.331 407.803 167.364 407.791C167.397 407.78 167.433 407.776 167.468 407.779L176.509 408.213C176.543 408.215 176.576 408.223 176.606 408.236C176.636 408.25 176.663 408.269 176.686 408.293C176.708 408.316 176.726 408.344 176.737 408.374C176.748 408.403 176.753 408.435 176.751 408.467C176.749 408.498 176.74 408.529 176.726 408.557C176.711 408.586 176.691 408.612 176.666 408.633C176.641 408.654 176.612 408.67 176.58 408.68C176.548 408.691 176.515 408.695 176.481 408.693L167.727 408.276C167.877 411.611 168.927 440.927 158.825 450.5C156.787 452.45 154.291 453.923 151.536 454.799C148.782 455.675 145.847 455.93 142.968 455.545Z"
        fill="#00112B"
      />
      <path
        d="M167.208 338.237C167.661 338.758 167.96 339.427 167.967 340.147C167.954 340.75 167.619 341.231 167.126 341.498C166.845 341.608 166.656 341.221 166.937 341.111C167.324 340.922 167.553 340.521 167.539 340.102C167.436 339.52 167.226 339.016 166.842 338.543C166.763 338.436 166.801 338.31 166.849 338.241C167.013 338.152 167.129 338.131 167.208 338.237Z"
        fill="#011533"
      />
      <path
        d="M99.3957 484.764L98.7667 484.626C99.4607 481.473 99.4027 480.111 99.2347 479.527C99.0347 478.837 98.7117 478.433 98.2727 478.333C97.6887 478.198 96.8727 478.608 96.1467 479.401C95.4717 480.14 94.6297 480.415 93.8907 480.131C93.1487 479.847 92.6807 479.072 92.6707 478.107C92.6227 473.08 91.6447 469.153 89.6797 466.097C89.1217 465.229 88.2987 464.709 87.6337 464.806C87.2147 464.867 86.9107 465.174 86.7597 465.697C86.6177 466.177 86.0047 467.72 83.9837 467.329C81.8997 466.926 80.0507 463.531 79.0567 461.708C78.9087 461.437 78.7887 461.215 78.6957 461.056C78.0337 459.937 77.1657 459.472 76.1847 459.708C74.3807 460.14 72.6577 462.712 72.4997 465.209C72.4317 466.287 72.4577 467.675 72.5707 468.92L71.9287 468.978C71.8127 467.701 71.7867 466.278 71.8577 465.167C72.0347 462.367 73.9487 459.578 76.0367 459.078C77.3017 458.775 78.4437 459.359 79.2537 460.727C79.3507 460.892 79.4757 461.121 79.6277 461.402C80.5027 463.009 82.3257 466.355 84.1137 466.7C85.5007 466.968 85.9817 466.074 86.1457 465.519C86.3717 464.748 86.8727 464.267 87.5497 464.17C88.4727 464.035 89.5247 464.658 90.2287 465.752C92.2607 468.911 93.2717 472.951 93.3227 478.104C93.3297 478.798 93.6387 479.343 94.1267 479.53C94.6137 479.718 95.1787 479.514 95.6757 478.969C96.5727 477.985 97.6017 477.514 98.4247 477.707C98.8927 477.817 99.5247 478.191 99.8607 479.35C100.129 480.302 99.9737 482.125 99.3957 484.764Z"
        fill="#4F5B94"
      />
      <path
        d="M89.5703 491.754C89.2473 479.705 84.7423 470.773 84.6973 470.682L85.2723 470.389C85.3173 470.479 89.8893 479.534 90.2153 491.738L89.5703 491.754Z"
        fill="#4F5B94"
      />
      <path
        d="M99.4873 494.532C99.3613 494.532 99.2393 494.532 99.1103 494.529L99.1193 493.884C102.901 493.945 105.709 493.103 106.996 491.512C107.716 490.625 107.935 489.531 107.645 488.263C107.296 486.736 106.29 485.626 104.734 485.055C101.901 484.013 97.6163 484.92 94.5473 487.211C90.8683 489.957 88.7583 494.349 88.7383 494.394L88.1543 494.116C88.2413 493.929 90.3553 489.534 94.1603 486.694C97.4453 484.242 101.885 483.319 104.957 484.452C106.728 485.103 107.874 486.372 108.274 488.124C108.606 489.576 108.335 490.889 107.496 491.925C106.131 493.61 103.292 494.532 99.4873 494.532Z"
        fill="#4F5B94"
      />
      <path
        d="M88.1254 494.288C87.4834 488.335 85.9214 484.595 84.7214 482.504C83.4274 480.245 82.2684 479.377 82.2554 479.367C81.9264 479.132 81.6584 479.028 81.5004 479.077C81.2874 479.144 81.1454 479.548 81.0194 479.9C80.8654 480.342 80.7164 480.758 80.3484 480.903C80.1484 480.981 79.9294 480.958 79.6964 480.832C79.1704 480.551 78.9834 479.967 78.7064 479.08C78.2094 477.508 77.3794 474.878 73.8494 470.996C72.8784 469.928 69.4774 466.498 66.5604 467.247C65.7884 467.444 65.2374 467.944 65.0854 468.58C64.9204 469.257 64.3104 469.696 63.6304 469.619C62.6624 469.509 60.2514 469.389 58.8094 470.577C58.1244 471.142 57.7374 471.942 57.6574 472.958C57.3864 476.366 61.7714 477.879 65.2984 479.096C67.0534 479.699 68.5674 480.222 69.1994 480.9C69.5094 481.229 69.5254 481.555 69.4834 481.768C69.3154 482.649 67.8444 483.349 66.6634 483.911C66.2404 484.111 65.8434 484.301 65.6664 484.43C65.1374 484.814 64.5984 485.518 64.8274 486.24C65.0014 486.802 65.9374 488.122 70.7934 488.218C75.1664 488.309 77.7934 489.874 79.2254 491.171C80.7944 492.591 81.3104 493.985 81.3324 494.043L80.7264 494.262C80.7064 494.211 78.7154 489.022 70.7804 488.861C65.9474 488.761 64.5404 487.483 64.2104 486.428C63.9394 485.563 64.3624 484.569 65.2884 483.901C65.5144 483.74 65.8984 483.556 66.3894 483.323C67.2704 482.904 68.7474 482.2 68.8514 481.642C68.8644 481.574 68.8604 481.477 68.7284 481.335C68.2054 480.774 66.6924 480.254 65.0884 479.699C61.5484 478.48 56.7014 476.808 57.0144 472.9C57.1114 471.703 57.5764 470.754 58.3994 470.074C59.9744 468.773 62.3974 468.825 63.7014 468.97C64.0524 469.012 64.3724 468.78 64.4594 468.421C64.6694 467.547 65.3954 466.872 66.4024 466.614C67.4574 466.343 70.3514 466.185 74.3274 470.554C77.9544 474.543 78.8124 477.257 79.3224 478.88C79.5614 479.638 79.7064 480.1 80.0034 480.254C80.0774 480.293 80.1134 480.296 80.1194 480.293C80.2134 480.258 80.3454 479.88 80.4164 479.677C80.5904 479.18 80.7904 478.615 81.3134 478.451C81.6844 478.334 82.1174 478.46 82.6394 478.835C82.8394 478.98 87.5094 482.504 88.7704 494.208L88.1254 494.288Z"
        fill="#4F5B94"
      />
      <path
        d="M91.0093 494.491L90.5703 494.02C95.9723 488.986 102.048 487.402 102.11 487.385L102.268 488.012C102.21 488.024 96.2853 489.573 91.0093 494.491Z"
        fill="#4F5B94"
      />
      <path
        d="M83.5504 494.207C83.5404 484.142 67.4354 473.722 67.2734 473.619L67.6224 473.073C67.6644 473.099 71.8014 475.761 75.8804 479.66C81.3944 484.926 84.1924 489.821 84.1954 494.207H83.5504Z"
        fill="#4F5B94"
      />
      <path d="M64.0312 494.349H105.358" stroke="#4F5B94" />
      <path
        d="M249 0.5H24C11.021 0.5 0.5 11.0213 0.5 24V225C0.5 237.979 11.021 248.5 24 248.5H249C261.979 248.5 272.5 237.979 272.5 225V24C272.5 11.0213 261.979 0.5 249 0.5Z"
        fill="white"
        stroke="#E2E2FC"
      />
      <path
        d="M466 0.5H313C300.021 0.5 289.5 11.0213 289.5 24V225C289.5 237.979 300.021 248.5 313 248.5H466C478.979 248.5 489.5 237.979 489.5 225V24C489.5 11.0213 478.979 0.5 466 0.5Z"
        fill="white"
        stroke="#E2E2FC"
      />
      <g opacity="0.5" filter="url(#filter9_f_118_403)">
        <path
          d="M136.35 200.359C196.19 200.359 244.7 164.859 244.7 121.067C244.7 77.2749 196.19 41.7739 136.35 41.7739C76.51 41.7739 28 77.2749 28 121.067C28 164.859 76.51 200.359 136.35 200.359Z"
          fill="#E2E2FC"
        />
      </g>
      <mask
        id="mask0_118_403"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="50"
        y="22"
        width="182"
        height="212"
      >
        <path d="M231.812 22H50.8115V234H231.812V22Z" fill="white" />
      </mask>
      <g mask="url(#mask0_118_403)">
        <path
          d="M132.812 151H171.812L156.436 180C149.759 170.161 144.624 163.429 132.812 151Z"
          fill="#004360"
        />
        <path
          opacity="0.7"
          d="M108.812 209L119.275 151H165.782L175.812 209H108.812Z"
          fill="#FF798D"
        />
        <path
          d="M132.812 150C132.812 144.48 137.292 140 142.813 140C148.333 140 152.813 144.48 152.813 150"
          stroke="#273754"
          strokeMiterlimit="10"
        />
        <path d="M81.7617 108.028L82.0187 207.127" stroke="#273754" />
        <path
          d="M112.49 116.339C119.771 111.987 120.108 105.127 113.244 101.016L98.9118 92.4321L72.5479 108.192L86.8799 116.775C93.7439 120.886 105.21 120.69 112.49 116.339Z"
          fill="#495894"
        />
        <path
          d="M112.49 116.339C119.771 111.987 120.108 105.127 113.244 101.016L98.9118 92.4321L72.5479 108.192L86.8799 116.775C93.7439 120.886 105.21 120.69 112.49 116.339Z"
          fill="#495894"
        />
        <path
          d="M91.3959 68.5811C80.9859 68.5811 72.5479 76.6621 72.5479 86.6301L72.9179 107.823L109.504 98.9741V84.3551C109.504 74.3871 101.805 68.5811 91.3959 68.5811Z"
          fill="#273754"
        />
        <path
          d="M91.3959 68.5811C80.9859 68.5811 72.5479 76.6621 72.5479 86.6301L72.9179 107.823L109.504 98.9741V84.3551C109.504 74.3871 101.805 68.5811 91.3959 68.5811Z"
          fill="#273754"
        />
        <path
          d="M82.6198 56.2174L106.039 73.9674C89.4858 62.4264 73.4598 77.0994 73.4598 85.6294L73.0918 108.592L51.7598 87.4334V65.9464C52.8628 54.7924 73.7928 49.0004 82.6198 56.2174Z"
          fill="#C4C4FA"
        />
        <path
          d="M108.519 98.5661L109.003 98.4421L109.251 99.4111L108.767 99.5351L108.519 98.5661ZM73.1922 108.126L73.3162 108.611L73.0402 108.681L72.8392 108.48L73.1922 108.126ZM51.7482 87.4021C51.5532 87.2061 51.5522 86.8901 51.7482 86.6941C51.9432 86.4991 52.2592 86.4991 52.4552 86.6941L51.7482 87.4021ZM108.767 99.5351L73.3162 108.611L73.0682 107.642L108.519 98.5661L108.767 99.5351ZM72.8392 108.48L51.7482 87.4021L52.4552 86.6941L73.5452 107.773L72.8392 108.48Z"
          fill="#273754"
        />
        <path d="M91.8115 228H64.8115V234H91.8115V228Z" fill="white" />
        <path
          d="M155.951 207.126L167.77 147.141H220.161L231.45 207.126H155.951Z"
          fill="#C2D9F0"
        />
        <path
          d="M182.842 147.141C182.842 139.714 188.165 133.696 194.735 133.696C201.306 133.696 206.629 139.714 206.629 147.141"
          stroke="#273754"
          strokeMiterlimit="10"
        />
        <path
          d="M215.532 172.824C216.529 172.525 217.526 172.107 218.413 171.509C217.526 170.912 216.529 170.434 215.532 170.195C214.479 169.896 213.703 169 213.426 167.924C213.149 166.789 212.761 165.773 212.207 164.817C211.653 165.773 211.21 166.849 210.988 167.924C210.711 169.06 209.88 169.896 208.883 170.195C207.83 170.494 206.888 170.912 206.002 171.509C206.888 172.107 207.886 172.585 208.883 172.824C209.936 173.123 210.711 174.019 210.988 175.155C211.265 176.23 211.653 177.306 212.207 178.262C212.761 177.306 213.205 176.23 213.426 175.155C213.648 174.019 214.479 173.123 215.532 172.824Z"
          fill="white"
        />
        <path
          d="M219.446 181.902C220.017 181.902 220.481 181.439 220.481 180.868C220.481 180.297 220.017 179.833 219.446 179.833C218.875 179.833 218.412 180.297 218.412 180.868C218.412 181.439 218.875 181.902 219.446 181.902Z"
          fill="white"
        />
        <path
          d="M201.536 154.583C201.536 157.456 198.318 159.755 194.296 159.755C190.274 159.755 187.057 157.456 187.057 154.583"
          fill="white"
        />
        <path
          d="M189.047 147.141L167.328 152.312L168.466 147.141H189.047Z"
          fill="#273754"
        />
        <path
          d="M72.4453 213.383L81.2573 157.859H120.189L128.615 213.383H72.4453Z"
          fill="white"
          stroke="#E2E2FC"
          strokeMiterlimit="10"
        />
        <path
          d="M91.8145 157.86C91.9145 152.415 95.7474 148.099 100.373 148.176C104.867 148.293 108.502 152.532 108.601 157.86"
          stroke="#E2E2FC"
          strokeMiterlimit="10"
        />
        <path
          d="M114.411 167.544H87.2949V185.622H114.411V167.544Z"
          fill="#C2D9F0"
        />
        <path
          d="M161.544 91.7401C160.719 90.5671 146.546 119.051 149.182 146.927C149.475 150.025 150.028 151.912 151 157.633C152.501 166.473 161.178 205.21 161.178 205.21C161.178 205.21 169.08 203.774 173.158 203.081C173.158 165.473 165.275 155.209 165.275 155.209L172.186 110.575L172.664 91.7401H161.544Z"
          fill="#495894"
        />
        <path
          d="M163.561 116.26L164.363 97.7554L168.972 112.119L163.561 116.26Z"
          fill="#273754"
        />
        <path
          d="M167.282 202.811L161.789 170.93C161.356 168.381 159.784 159.126 159.278 156.146L160.894 145.665"
          stroke="#273754"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="9 9"
        />
        <path
          d="M161.308 204.582L161.029 211.081L148.486 217.148C146.661 218.224 145.217 219.818 144.377 221.747L144.301 221.942L168.488 217.834C170.108 217.486 171.399 216.283 171.785 214.686L172.728 202.643"
          fill="#F7C689"
        />
        <path
          d="M172.489 217.724L144.188 222.53L144.332 223.381L172.633 218.575L172.489 217.724Z"
          fill="#F27932"
        />
        <path
          d="M154.65 220.753C154.194 218.279 152.787 216.44 150.66 215.088L152.521 214.444C154.648 215.796 156.109 217.954 156.559 220.393"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M161.168 205.157L172.523 205.448L173.201 202.562L161.066 204.562L161.168 205.157Z"
          fill="#273754"
        />
        <path
          d="M161.213 209.399L172.953 209.775L172.348 213.086L160.125 211.37L161.213 209.399Z"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M166.536 218.233L167.217 212.576L169.495 212.882L170.295 217.595L166.536 218.233Z"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M162.681 92.7154C162.681 92.7154 170.691 95.3214 179.144 90.3364C179.144 90.3364 191.507 107.094 187.568 117.891C182.972 135.299 179.144 153.672 179.144 153.672L204.492 186.068L195.95 196.384L164.415 163.202C161.379 157.753 161.401 158.324 161.937 149.211L162.66 105.795L162.681 92.7154Z"
          fill="#495894"
        />
        <path
          d="M165.022 123.704C165.022 123.704 161.39 153.326 163.167 157.04C165.928 162.811 170.608 169.153 170.608 169.153"
          stroke="#273754"
          strokeMiterlimit="10"
        />
        <path
          d="M161.967 94.7632L156.676 104.464"
          stroke="#273754"
          strokeMiterlimit="10"
        />
        <path
          d="M174.808 94.7632C174.808 94.7632 173.224 101.193 180.845 104.464"
          stroke="#273754"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M200.302 188.486L174.313 155.606C173.583 153.013 173.796 149.727 174.313 145.59L179.484 110.943"
          stroke="#273754"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="9 9"
        />
        <path
          d="M156.911 56.06C155.035 51.63 156.055 46.272 158.705 42.264C161.356 38.256 165.434 35.513 169.756 33.615C173.263 32.054 177.219 30.999 180.889 32.054C185.905 33.531 189.331 38.973 189.331 44.373C189.331 49.773 186.354 54.8781 182.194 58.1691C175.221 63.6111 161.356 66.522 156.911 56.06Z"
          fill="#273754"
        />
        <path
          d="M164.21 51.1431C164.21 51.1431 163.066 60.5961 161.086 63.0961C161.086 63.0961 166.102 68.4871 171.998 63.6041L170.414 50.2441"
          fill="#F7C689"
        />
        <path
          d="M161.863 63.6473C161.863 63.6473 154.588 59.0803 150.253 62.5753C145.918 66.0703 138.754 88.1913 138.754 88.1913L147.718 93.3533L156.729 78.3653L161.863 63.6473Z"
          fill="#F7C689"
        />
        <path
          d="M162.449 63.082C162.449 63.082 155.462 72.728 155.978 76.178C156.494 79.629 159.833 81.985 159.833 81.985L160.937 91.564C160.937 91.564 169.317 96.549 178.999 90.336L180.986 74.016C180.986 74.016 176.659 70.607 172.332 63.581C172.332 63.581 165.743 67.032 162.449 63.082Z"
          fill="#DADAFF"
        />
        <path
          d="M169.896 22.0382C168.84 21.8742 167.744 22.2442 166.962 23.0272C166.179 23.8102 165.553 24.7162 165.083 25.7042C164.457 26.8582 163.87 28.0932 163.753 29.4112C163.636 30.7292 164.223 32.2122 165.396 32.7062C166.57 33.2012 167.822 32.7482 168.84 31.9652C170.953 30.3592 174.357 22.9862 169.896 22.0382Z"
          fill="#273754"
        />
        <path
          d="M170.514 53.7123L170.117 49.9243L163.85 50.8503C163.85 50.8503 163.718 52.0713 163.453 53.7543C163.806 54.4283 164.336 54.9753 164.998 55.3543C166.145 55.9433 167.557 55.7333 168.661 55.1013C169.367 54.7233 169.985 54.2603 170.514 53.7123Z"
          fill="#F27932"
        />
        <path
          d="M165.691 36.469C161.394 39.852 160.952 44.102 161.113 48.048C161.273 51.995 164.968 54.336 166.735 54.076C168.502 53.816 174.485 51.084 174.565 42.888C174.646 34.691 168.06 34.605 165.691 36.469Z"
          fill="#F7C689"
        />
        <path
          d="M168.85 44.7541C169.421 44.7541 169.884 44.2901 169.884 43.7191C169.884 43.1481 169.421 42.6851 168.85 42.6851C168.278 42.6851 167.815 43.1481 167.815 43.7191C167.815 44.2901 168.278 44.7541 168.85 44.7541Z"
          fill="#1D2943"
        />
        <path
          d="M162.424 44.7541C162.995 44.7541 163.458 44.2901 163.458 43.7191C163.458 43.1481 162.995 42.6851 162.424 42.6851C161.853 42.6851 161.39 43.1481 161.39 43.7191C161.39 44.2901 161.853 44.7541 162.424 44.7541Z"
          fill="#1D2943"
        />
        <path
          d="M174.518 44.7542C174.954 44.1592 175.707 43.8252 176.46 43.8252C177.252 43.8622 177.926 44.2712 178.282 44.9402C178.559 45.6092 178.401 46.3902 177.886 46.9112C176.895 47.9522 175.112 47.6542 174.756 47.5802C174.36 47.5052 174.082 47.2452 173.924 46.9112"
          fill="#F7C689"
        />
        <path
          d="M180.344 67.5762L180.986 79.7722"
          stroke="#F27932"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M168.338 47.855C168.065 48.772 167.69 49.623 167.281 50.343C166.838 51.063 166.259 51.259 165.713 50.866C165.202 50.408 164.759 48.903 164.486 47.921C165.611 47.79 167.179 47.986 168.338 47.855Z"
          fill="white"
        />
        <path
          d="M166.225 80.317C169.301 82.602 173.691 81.99 175.988 78.929C176.522 78.236 176.891 77.42 177.137 76.562"
          stroke="#273754"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M175.849 42.5413C172.474 42.1823 169.417 39.0323 168.146 35.5223C172.832 35.0723 175.611 38.3573 175.849 42.5413Z"
          fill="#273754"
        />
        <path
          d="M122.588 50.271C124.082 52.817 149.198 89.96 149.198 89.96C149.198 89.96 148.527 93.905 146.699 95.313C143.646 97.667 139.341 96.282 137.064 93.172C126.22 78.365 113.833 55.19 113.833 55.19"
          fill="#F7C689"
        />
        <path
          d="M132.91 32.0884L112.901 40.5014L126.325 72.4254L146.334 64.0124L132.91 32.0884Z"
          fill="white"
          stroke="#273754"
        />
        <path
          d="M131.573 60.5024L129.232 61.4864L128.258 45.8584L130.636 44.8584L131.573 60.5024Z"
          fill="#004360"
        />
        <path
          d="M122.55 48.8651C120.951 49.5371 120.197 51.383 120.869 52.98C121.54 54.577 123.388 55.329 124.986 54.657C126.584 53.986 127.338 52.1391 126.667 50.5421C125.995 48.9461 124.148 48.1931 122.55 48.8651ZM124.252 52.9121C123.62 53.1781 122.881 52.877 122.615 52.245C122.35 51.614 122.652 50.8761 123.284 50.6101C123.915 50.3441 124.654 50.645 124.92 51.277C125.223 51.892 124.884 52.6471 124.252 52.9121Z"
          fill="#004360"
        />
        <path
          d="M135.012 52.1884C133.414 52.8604 132.66 54.7074 133.331 56.3044C134.003 57.9004 135.851 58.6534 137.449 57.9814C139.047 57.3094 139.801 55.4634 139.13 53.8664C138.405 52.2484 136.574 51.5324 135.012 52.1884ZM136.715 56.2364C136.083 56.5024 135.344 56.2004 135.078 55.5694C134.813 54.9384 135.115 54.1994 135.746 53.9344C136.378 53.6684 137.117 53.9694 137.383 54.6004C137.648 55.2324 137.347 55.9704 136.715 56.2364Z"
          fill="#004360"
        />
        <path
          d="M116.557 60.217L113.359 54.688C112.662 53.46 112.283 52.027 112.244 50.625C112.209 49.867 112.736 49.204 113.471 49.009L114.089 48.846L113.637 47.916C113.47 47.597 113.447 47.2 113.551 46.809C113.702 46.285 114.135 45.889 114.676 45.746L114.792 45.715L114.615 45.358C114.398 44.851 114.452 44.272 114.787 43.82C115.094 43.416 115.566 43.17 116.06 43.16L116.883 43.145L125.632 43.858C125.632 43.858 125.387 46.061 123.558 46.182C123.558 46.182 123.563 48.077 122.035 48.4C120.508 48.723 120.245 48.51 120.245 48.51L122.145 48.815C122.145 48.815 122.227 50.689 121.008 50.77C119.788 50.85 116.825 50.746 116.825 50.746L119.275 50.784"
          fill="#F7C689"
        />
        <path
          d="M123.403 45.709L116.172 45.807"
          stroke="#F27932"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M121.531 48.9252L114.924 47.9502"
          stroke="#F27932"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M120.285 51.0691L115.598 50.4941"
          stroke="#F27932"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M165.691 40.6341C164.663 39.9691 163.575 40.2761 162.418 41.0621C163.573 40.8531 164.563 40.8521 165.691 40.6341Z"
          fill="#273754"
          stroke="#273754"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M173.116 41.2582C171.95 40.5842 170.135 40.4272 168.623 40.8542C170.178 40.9442 171.561 41.1232 173.116 41.2582Z"
          fill="#273754"
          stroke="#273754"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.167 43.7192L165.525 45.8052L165.788 46.2862"
          stroke="#273754"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M162.937 45.7872C164.365 45.7872 165.523 44.6302 165.523 43.2022C165.523 41.7742 164.365 40.6162 162.937 40.6162C161.509 40.6162 160.352 41.7742 160.352 43.2022C160.352 44.6302 161.509 45.7872 162.937 45.7872Z"
          stroke="#F27932"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M170.175 45.7872C171.603 45.7872 172.761 44.6302 172.761 43.2022C172.761 41.7742 171.603 40.6162 170.175 40.6162C168.747 40.6162 167.59 41.7742 167.59 43.2022C167.59 44.6302 168.747 45.7872 170.175 45.7872Z"
          stroke="#F27932"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M180.002 73.7111C180.369 74.6881 179.921 76.8311 180.002 77.8481C180.206 81.1041 186.257 93.8791 187.569 97.4981C187.896 101.635 187.052 108.69 186.212 116.115C186.497 120.226 186.212 117.666 185.177 121.286C185.096 125.275 184.395 123.589 182.075 127.491C181.339 128.729 179.151 129.437 180.006 129.559C180.617 129.682 182.994 128.531 183.626 128.008C185.501 126.457 185.323 128.024 186.212 126.974C187.763 125.14 187.052 129.559 187.052 129.559L187.763 133.179C188.74 133.179 186.786 133.179 187.763 133.179C186.745 133.179 191.706 125.94 192.223 124.388C192.74 122.837 194.039 119.132 194.161 116.527C194.365 113.23 197.843 99.2851 197.721 95.9471C197.531 90.7761 195.045 87.1561 194.161 82.5021C193.137 77.1041 192.413 75.7801 191.706 70.3171C191.275 66.9891 189.638 64.4151 187.052 62.8521C183.949 61.8181 181.04 61.3011 178.26 61.8181C176.043 62.8521 171.729 63.8981 171.729 63.8981C172.95 66.0141 174.416 67.9681 176.044 69.8001C178.568 72.5271 180.002 73.7111 180.002 73.7111Z"
          fill="#F7C689"
        />
        <path
          d="M184.537 112L182.246 119.294L178.675 125.585L175.309 129.225C175.309 129.225 176.073 131.913 182.884 126.744C183.266 126.463 183.729 126.566 184.039 126.902C184.195 127.07 184.213 127.347 184.184 127.594L182.65 134.619L182.098 137.323C181.95 137.957 182.356 138.553 182.941 138.671C183.188 138.699 183.434 138.727 183.648 138.602L185.854 133.462C185.854 133.462 189.575 126.298 190.724 121.319C191.309 118.784 191.708 114.73 191.708 114.73"
          fill="#F7C689"
        />
        <path
          d="M204.385 185.976C204.358 186.356 207.722 191.827 209.046 194.786C209.415 195.606 209.344 196.52 208.915 197.292L196.054 219.117L195.947 218.867C195.006 216.537 194.863 213.953 195.57 211.525L198.348 202.005L195.247 196.013"
          fill="#F7C689"
        />
        <path
          d="M211.094 194.472L196.166 220.372L196.945 220.82L211.872 194.92L211.094 194.472Z"
          fill="#F27932"
        />
        <path
          d="M201.709 210.849C199.43 209.558 197.006 209.492 194.543 210.298L195.279 208.394C197.742 207.587 200.455 207.842 202.729 209.096"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M196.634 195.638L205.688 187.652L204.054 185.696L196.21 195.095L196.634 195.638Z"
          fill="#273754"
        />
        <path
          d="M196.782 197.756L206.041 187.857L207.719 191.223L197.667 199.943L196.782 197.756Z"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M207.046 199.676L202.983 195.371L204.7 193.755L209.059 196.25L207.046 199.676Z"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M159.844 39.3743C160.966 38.1783 162.233 37.1263 163.598 36.2183C165.109 35.1663 166.718 34.2583 168.375 33.4453C171.592 31.8673 175.053 30.7193 178.709 30.7673C182.462 30.8153 186.069 32.1543 188.555 35.0233C190.847 37.7483 192.065 41.1913 191.919 44.7293C191.821 48.6503 190.262 52.4753 188.019 55.6783C187.727 56.0613 187.483 56.4433 187.142 56.8263C186.947 57.0653 187.386 57.3043 187.581 57.0653C190.067 53.9093 191.87 50.1323 192.309 46.1633C192.748 42.5293 191.821 38.8483 189.725 35.7883C188.702 34.3053 187.386 33.1103 185.826 32.1543C184.168 31.1973 182.316 30.6243 180.366 30.3853C176.613 29.9543 172.908 30.8153 169.496 32.3453C167.741 33.1103 166.035 34.0183 164.427 35.0703C162.915 35.9793 161.551 37.0313 160.234 38.2263C159.942 38.5133 159.698 38.7523 159.406 39.0393C159.113 39.3263 159.649 39.6133 159.844 39.3743Z"
          fill="#273754"
        />
        <path d="M163.659 114.887L168.83 115.921" stroke="#0B2456" />
      </g>
      <mask
        id="mask1_118_403"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="324"
        y="45"
        width="143"
        height="168"
      >
        <path d="M466.999 45H324.461V213H466.999V45Z" fill="white" />
      </mask>
      <g mask="url(#mask1_118_403)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M465.489 65.0419L405.834 46.4399L399.876 65.5049L396.906 75.0079L359.956 193.244L419.611 211.846L465.489 65.0419ZM435.653 81.7779C434.294 86.1229 429.778 88.5819 425.566 87.2689C422.002 86.1589 420.884 83.1259 419.863 80.3559C419.261 78.7219 418.692 77.1789 417.675 76.1759C418.937 75.8799 420.163 75.0009 421.474 74.0599C423.917 72.3069 426.658 70.3409 430.486 71.5339C434.698 72.8469 437.011 77.4329 435.653 81.7779Z"
          fill="white"
        />
        <path
          d="M405.836 46.4398L405.974 46.0008L405.534 45.8638L405.397 46.3038L405.836 46.4398ZM465.491 65.0418L465.93 65.1778L466.067 64.7398L465.628 64.6028L465.491 65.0418ZM359.958 193.244L359.519 193.108L359.382 193.546L359.821 193.683L359.958 193.244ZM419.613 211.846L419.475 212.285L419.915 212.422L420.052 211.982L419.613 211.846ZM419.865 80.3558L420.297 80.1968L420.287 80.1688L420.273 80.1418L419.865 80.3558ZM419.865 80.3558L419.433 80.5148L419.444 80.5428L419.457 80.5698L419.865 80.3558ZM417.677 76.1758L417.573 75.7288L416.761 75.9188L417.354 76.5038L417.677 76.1758ZM405.698 46.8788L465.353 65.4808L465.628 64.6028L405.974 46.0008L405.698 46.8788ZM400.317 65.6418L406.275 46.5768L405.397 46.3038L399.439 65.3688L400.317 65.6418ZM397.348 75.1448L400.317 65.6418L399.439 65.3688L396.469 74.8718L397.348 75.1448ZM360.398 193.381L397.348 75.1448L396.469 74.8718L359.519 193.108L360.398 193.381ZM419.751 211.407L360.096 192.805L359.821 193.683L419.475 212.285L419.751 211.407ZM465.051 64.9048L419.174 211.709L420.052 211.982L465.93 65.1778L465.051 64.9048ZM425.43 87.7078C429.898 89.0998 434.663 86.4888 436.094 81.9148L435.215 81.6418C433.928 85.7568 429.662 88.0628 425.705 86.8298L425.43 87.7078ZM419.433 80.5148C420.444 83.2568 421.623 86.5218 425.43 87.7078L425.705 86.8298C422.385 85.7948 421.328 82.9948 420.297 80.1968L419.433 80.5148ZM417.354 76.5038C418.283 77.4198 418.82 78.8518 419.433 80.5148L420.297 80.1968C419.706 78.5918 419.106 76.9388 418.001 75.8488L417.354 76.5038ZM421.208 73.6868C419.873 74.6438 418.727 75.4578 417.573 75.7288L417.782 76.6238C419.151 76.3018 420.456 75.3568 421.744 74.4328L421.208 73.6868ZM430.626 71.0948C426.554 69.8258 423.632 71.9478 421.208 73.6868L421.744 74.4328C424.207 72.6668 426.766 70.8558 430.351 71.9728L430.626 71.0948ZM436.094 81.9148C437.524 77.3398 435.093 72.4868 430.626 71.0948L430.351 71.9728C434.307 73.2058 436.502 77.5258 435.215 81.6418L436.094 81.9148ZM399.509 65.3318C400.317 67.3468 401.968 69.2908 403.382 70.7118C404.094 71.4268 404.757 72.0198 405.242 72.4338C405.485 72.6418 405.683 72.8048 405.822 72.9158C405.891 72.9718 405.945 73.0148 405.982 73.0438C406.001 73.0588 406.016 73.0698 406.025 73.0778C406.03 73.0808 406.034 73.0838 406.037 73.0858C406.038 73.0868 406.039 73.0878 406.04 73.0888C406.04 73.0888 406.041 73.0888 406.041 73.0898C406.041 73.0898 406.041 73.0898 406.322 72.7248C406.603 72.3598 406.603 72.3598 406.603 72.3598C406.602 72.3598 406.602 72.3598 406.602 72.3598C406.602 72.3598 406.601 72.3588 406.6 72.3578C406.598 72.3568 406.595 72.3538 406.591 72.3508C406.582 72.3438 406.569 72.3338 406.552 72.3208C406.517 72.2938 406.466 72.2528 406.4 72.1998C406.268 72.0928 406.076 71.9358 405.841 71.7348C405.37 71.3328 404.726 70.7568 404.035 70.0628C402.643 68.6638 401.101 66.8268 400.363 64.9888L399.509 65.3318ZM406.322 72.7248C406.262 72.2688 406.262 72.2688 406.262 72.2688C406.261 72.2688 406.261 72.2688 406.261 72.2688C406.26 72.2698 406.258 72.2698 406.257 72.2698C406.254 72.2698 406.249 72.2708 406.243 72.2718C406.231 72.2728 406.213 72.2758 406.189 72.2788C406.143 72.2858 406.074 72.2948 405.986 72.3078C405.809 72.3338 405.554 72.3728 405.238 72.4238C404.605 72.5268 403.725 72.6818 402.739 72.8888C400.776 73.3008 398.347 73.9298 396.595 74.7888L396.999 75.6138C398.642 74.8088 400.975 74.1988 402.927 73.7888C403.897 73.5848 404.762 73.4328 405.384 73.3318C405.696 73.2808 405.946 73.2428 406.118 73.2178C406.204 73.2058 406.27 73.1958 406.315 73.1898C406.337 73.1868 406.354 73.1848 406.366 73.1828C406.371 73.1818 406.375 73.1818 406.378 73.1808C406.379 73.1808 406.38 73.1808 406.381 73.1808C406.381 73.1808 406.382 73.1808 406.322 72.7248ZM406.184 73.1638L417.663 76.7408L417.938 75.8628L406.46 72.2858L406.184 73.1638Z"
          fill="#C4C4FA"
        />
        <path
          d="M447.281 101.804L398.979 86.7256L393.222 105.168L441.524 120.246L447.281 101.804Z"
          fill="#E2E2FC"
        />
        <path
          d="M421.511 184.355L373.21 169.277L367.453 187.719L415.754 202.797L421.511 184.355Z"
          fill="#E2E2FC"
        />
        <path
          d="M434.122 143.958L385.82 128.88L383.079 137.662L431.38 152.74L434.122 143.958Z"
          fill="#E2E2FC"
        />
        <path
          d="M430.012 157.131L381.711 142.053L378.969 150.835L427.271 165.913L430.012 157.131Z"
          fill="#E2E2FC"
        />
        <path
          d="M426.777 170.578L378.476 155.5L375.734 164.282L424.035 179.36L426.777 170.578Z"
          fill="#E2E2FC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M391.239 46.4399H328.68V200.188H391.239V46.4399ZM367.743 71.2729C367.743 75.8209 364.164 79.5079 359.748 79.5079C356.012 79.5079 354.038 76.9479 352.235 74.6089C351.172 73.2299 350.168 71.9279 348.897 71.2729C350.014 70.6159 350.922 69.4129 351.893 68.1259C353.704 65.7279 355.734 63.0379 359.748 63.0379C364.164 63.0379 367.743 66.7249 367.743 71.2729ZM337.037 71.3649C337.037 71.3649 331.307 69.2639 328.68 66.0509V76.5559C331.426 73.9609 337.037 71.3649 337.037 71.3649Z"
          fill="white"
        />
        <path
          d="M328.68 46.44V45.98H328.22V46.44H328.68ZM391.239 46.44H391.699V45.98H391.239V46.44ZM328.68 200.188H328.22V200.648H328.68V200.188ZM391.239 200.188V200.648H391.699V200.188H391.239ZM348.897 71.273L348.663 70.877L347.944 71.3L348.686 71.682L348.897 71.273ZM328.68 66.051L329.036 65.76L328.22 64.761V66.051H328.68ZM337.037 71.365L337.23 71.783L338.239 71.316L337.196 70.933L337.037 71.365ZM328.68 76.556H328.22V77.624L328.996 76.89L328.68 76.556ZM328.68 46.9H391.239V45.98H328.68V46.9ZM329.14 200.188V46.44H328.22V200.188H329.14ZM391.239 199.728H328.68V200.648H391.239V199.728ZM390.779 46.44V200.188H391.699V46.44H390.779ZM359.748 79.968C364.43 79.968 368.203 76.062 368.203 71.273H367.283C367.283 75.58 363.897 79.048 359.748 79.048V79.968ZM351.871 74.89C353.656 77.205 355.757 79.968 359.748 79.968V79.048C356.266 79.048 354.421 76.69 352.6 74.328L351.871 74.89ZM348.686 71.682C349.848 72.28 350.788 73.486 351.871 74.89L352.6 74.328C351.555 72.974 350.488 71.575 349.107 70.864L348.686 71.682ZM351.526 67.849C350.537 69.158 349.685 70.275 348.663 70.877L349.13 71.669C350.342 70.956 351.306 69.667 352.261 68.403L351.526 67.849ZM359.748 62.578C355.479 62.578 353.322 65.47 351.526 67.849L352.261 68.403C354.085 65.986 355.989 63.498 359.748 63.498V62.578ZM368.203 71.273C368.203 66.484 364.43 62.578 359.748 62.578V63.498C363.897 63.498 367.283 66.966 367.283 71.273H368.203ZM328.324 66.342C329.697 68.022 331.855 69.386 333.629 70.32C334.523 70.791 335.333 71.159 335.92 71.41C336.214 71.535 336.452 71.631 336.617 71.697C336.7 71.729 336.765 71.754 336.809 71.771C336.831 71.779 336.848 71.786 336.86 71.79C336.866 71.792 336.87 71.794 336.874 71.795C336.875 71.796 336.876 71.796 336.877 71.796C336.878 71.797 336.878 71.797 336.878 71.797H336.879C336.879 71.797 336.879 71.797 337.037 71.365C337.196 70.933 337.196 70.933 337.196 70.933H337.195C337.195 70.933 337.194 70.933 337.193 70.932C337.19 70.931 337.186 70.93 337.181 70.928C337.171 70.924 337.156 70.919 337.135 70.911C337.095 70.895 337.033 70.872 336.954 70.841C336.796 70.778 336.566 70.685 336.282 70.564C335.712 70.32 334.925 69.962 334.058 69.506C332.311 68.586 330.289 67.292 329.036 65.76L328.324 66.342ZM329.14 76.556V66.051H328.22V76.556H329.14ZM337.037 71.365C336.844 70.948 336.844 70.948 336.844 70.948C336.843 70.948 336.843 70.948 336.843 70.948C336.842 70.949 336.841 70.949 336.839 70.95C336.836 70.951 336.832 70.953 336.827 70.956C336.815 70.961 336.799 70.969 336.778 70.979C336.735 70.999 336.672 71.028 336.592 71.067C336.431 71.144 336.199 71.257 335.912 71.4C335.339 71.686 334.545 72.095 333.664 72.586C331.913 73.562 329.781 74.882 328.364 76.222L328.996 76.89C330.325 75.634 332.371 74.36 334.112 73.389C334.978 72.907 335.759 72.504 336.323 72.223C336.605 72.082 336.833 71.972 336.989 71.897C337.068 71.859 337.128 71.83 337.169 71.811C337.19 71.802 337.205 71.794 337.215 71.79C337.221 71.787 337.224 71.785 337.227 71.784C337.228 71.784 337.229 71.783 337.23 71.783C337.23 71.783 337.23 71.783 337.037 71.365ZM337.037 71.825H349.067V70.905H337.037V71.825Z"
          fill="#C4C4FA"
        />
        <path
          d="M330.962 68.7346L327.312 65.7456L327.747 76.4346L329.072 75.5596L331.142 73.9516L330.962 68.7346Z"
          fill="white"
        />
        <path
          d="M384.797 86.9199H334.197V192.72H384.797V86.9199Z"
          fill="#E2E2FC"
        />
        <path
          d="M358.814 131.08L355.98 131.079L361.737 114.52L364.616 114.521L358.814 131.08Z"
          fill="#004360"
        />
        <path
          d="M354.57 115.146C352.635 115.146 351.061 116.725 351.061 118.665C351.061 120.606 352.636 122.185 354.57 122.185C356.504 122.185 358.079 120.606 358.079 118.666C358.079 116.726 356.504 115.146 354.57 115.146ZM354.57 120.064C353.805 120.064 353.175 119.433 353.175 118.666C353.175 117.899 353.805 117.267 354.57 117.267C355.334 117.267 355.964 117.899 355.964 118.666C356.009 119.433 355.335 120.065 354.57 120.064Z"
          fill="#004360"
        />
        <path
          d="M365.95 123.989C364.016 123.989 362.441 125.568 362.442 127.508C362.442 129.448 364.016 131.028 365.951 131.028C367.885 131.028 369.46 129.449 369.46 127.509C369.414 125.523 367.84 123.989 365.95 123.989ZM365.951 128.907C365.186 128.907 364.556 128.275 364.556 127.508C364.556 126.741 365.186 126.11 365.95 126.11C366.715 126.11 367.345 126.742 367.345 127.509C367.345 128.276 366.715 128.907 365.951 128.907Z"
          fill="#004360"
        />
        <path
          d="M347.623 149.857C349.978 149.857 351.391 148.149 351.391 146.118C351.391 144.101 349.978 142.394 347.623 142.394C345.283 142.394 343.869 144.101 343.869 146.118C343.869 148.149 345.283 149.857 347.623 149.857ZM347.623 148.193C346.46 148.193 345.812 147.237 345.812 146.118C345.812 145.014 346.46 144.057 347.623 144.057C348.786 144.057 349.448 145.014 349.448 146.118C349.448 147.237 348.786 148.193 347.623 148.193ZM355.075 149.68V144.204H356.517V142.57H355.075V142.188C355.075 141.525 355.443 141.187 355.958 141.187C356.296 141.187 356.547 141.29 356.738 141.481L357.444 140.377C356.988 139.891 356.267 139.715 355.59 139.715C354.162 139.715 353.19 140.672 353.19 142.188V142.57H352.013V144.204H353.19V149.68H355.075ZM359.89 149.68V144.204H361.333V142.57H359.89V142.188C359.89 141.525 360.258 141.187 360.773 141.187C361.112 141.187 361.362 141.29 361.554 141.481L362.26 140.377C361.804 139.891 361.083 139.715 360.405 139.715C358.978 139.715 358.006 140.672 358.006 142.188V142.57H356.828V144.204H358.006V149.68H359.89ZM365.751 149.857C366.855 149.857 367.974 149.518 368.68 148.871L367.856 147.664C367.4 148.105 366.561 148.37 365.957 148.37C364.75 148.37 364.029 147.619 363.911 146.721H369.195V146.309C369.195 143.984 367.753 142.394 365.633 142.394C363.469 142.394 361.953 144.057 361.953 146.118C361.953 148.4 363.587 149.857 365.751 149.857ZM367.385 145.456H363.882C363.97 144.749 364.47 143.88 365.633 143.88C366.87 143.88 367.341 144.778 367.385 145.456ZM372.415 149.68V144.984C372.724 144.528 373.549 144.175 374.167 144.175C374.373 144.175 374.55 144.19 374.682 144.219V142.394C373.799 142.394 372.916 142.909 372.415 143.542V142.57H370.546V149.68H372.415Z"
          fill="#273754"
        />
        <path
          d="M400.998 68L398.498 64L394.998 75.5L397.499 74.356L399.498 73L400.998 68Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_118_403"
        x="-16.9678"
        y="185.674"
        width="531.262"
        height="410.966"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="62.5"
          result="effect1_foregroundBlur_118_403"
        />
      </filter>
      <filter
        id="filter1_d_118_403"
        x="376.195"
        y="430.678"
        width="28.6699"
        height="45.1196"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.886275 0 0 0 0 0.886275 0 0 0 0 0.988235 0 0 0 0.8 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_118_403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_118_403"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_118_403"
        x="380.001"
        y="424.129"
        width="38.1377"
        height="70.3306"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.215686 0 0 0 0 0.329412 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_118_403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_118_403"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_118_403"
        x="322.632"
        y="389.752"
        width="28.4834"
        height="33.6777"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_118_403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_118_403"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_118_403"
        x="322.172"
        y="388.795"
        width="30.2783"
        height="33.8027"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_118_403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_118_403"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_118_403"
        x="269.145"
        y="344.208"
        width="28.333"
        height="34.0708"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_118_403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_118_403"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_d_118_403"
        x="310.001"
        y="479"
        width="73.7324"
        height="37.4097"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.215686 0 0 0 0 0.329412 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_118_403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_118_403"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_d_118_403"
        x="61.5537"
        y="404.155"
        width="60.0615"
        height="67.4199"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.215686 0 0 0 0 0.329412 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_118_403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_118_403"
          result="shape"
        />
      </filter>
      <filter
        id="filter8_d_118_403"
        x="137.248"
        y="478.535"
        width="74.4727"
        height="37.6587"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.215686 0 0 0 0 0.329412 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_118_403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_118_403"
          result="shape"
        />
      </filter>
      <filter
        id="filter9_f_118_403"
        x="-97"
        y="-83.2261"
        width="466.7"
        height="408.585"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="62.5"
          result="effect1_foregroundBlur_118_403"
        />
      </filter>
      <clipPath id="clip0_118_403">
        <rect width="490" height="516" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default LogInIllustration
